// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: todo.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { PaginationMeta, PaginationRequest } from "./common";
import { Struct } from "./google/protobuf/struct";
import { Timestamp } from "./google/protobuf/timestamp";
import { User } from "./user";

export const protobufPackage = "familyos.v1";

/**
 * Family OS — Todo, Todo completions, daily brief.
 *
 * See common.proto for design notes on enum-as-string and timestamps.
 */

/**
 * Scope for edits/claims targeting a recurring todo. UNSPECIFIED is
 * treated as SERIES on the server (back-compat: existing clients
 * silently update the series). INSTANCE forks the row: the current
 * occurrence becomes a one-off carrying the edited fields, and the
 * series advances its due_at to the next rule match.
 */
export enum RecurringScope {
  RECURRING_SCOPE_UNSPECIFIED = 0,
  RECURRING_SCOPE_SERIES = 1,
  RECURRING_SCOPE_INSTANCE = 2,
  UNRECOGNIZED = -1,
}

export function recurringScopeFromJSON(object: any): RecurringScope {
  switch (object) {
    case 0:
    case "RECURRING_SCOPE_UNSPECIFIED":
      return RecurringScope.RECURRING_SCOPE_UNSPECIFIED;
    case 1:
    case "RECURRING_SCOPE_SERIES":
      return RecurringScope.RECURRING_SCOPE_SERIES;
    case 2:
    case "RECURRING_SCOPE_INSTANCE":
      return RecurringScope.RECURRING_SCOPE_INSTANCE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RecurringScope.UNRECOGNIZED;
  }
}

export function recurringScopeToJSON(object: RecurringScope): string {
  switch (object) {
    case RecurringScope.RECURRING_SCOPE_UNSPECIFIED:
      return "RECURRING_SCOPE_UNSPECIFIED";
    case RecurringScope.RECURRING_SCOPE_SERIES:
      return "RECURRING_SCOPE_SERIES";
    case RecurringScope.RECURRING_SCOPE_INSTANCE:
      return "RECURRING_SCOPE_INSTANCE";
    case RecurringScope.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Buckets that MoveTodo accepts as a target. "Upcoming" is intentionally
 * absent — it's a derived view (any item whose due_at falls beyond end of
 * tomorrow), not a target users move into. TOMORROW is a discrete target
 * (set due_at = end-of-next-local-day) so the web drag-to-tomorrow zone
 * stays server-policy-owned alongside today/inbox.
 */
export enum TodoBucket {
  TODO_BUCKET_UNSPECIFIED = 0,
  TODO_BUCKET_TODAY = 1,
  TODO_BUCKET_INBOX = 2,
  TODO_BUCKET_TOMORROW = 3,
  UNRECOGNIZED = -1,
}

export function todoBucketFromJSON(object: any): TodoBucket {
  switch (object) {
    case 0:
    case "TODO_BUCKET_UNSPECIFIED":
      return TodoBucket.TODO_BUCKET_UNSPECIFIED;
    case 1:
    case "TODO_BUCKET_TODAY":
      return TodoBucket.TODO_BUCKET_TODAY;
    case 2:
    case "TODO_BUCKET_INBOX":
      return TodoBucket.TODO_BUCKET_INBOX;
    case 3:
    case "TODO_BUCKET_TOMORROW":
      return TodoBucket.TODO_BUCKET_TOMORROW;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TodoBucket.UNRECOGNIZED;
  }
}

export function todoBucketToJSON(object: TodoBucket): string {
  switch (object) {
    case TodoBucket.TODO_BUCKET_UNSPECIFIED:
      return "TODO_BUCKET_UNSPECIFIED";
    case TodoBucket.TODO_BUCKET_TODAY:
      return "TODO_BUCKET_TODAY";
    case TodoBucket.TODO_BUCKET_INBOX:
      return "TODO_BUCKET_INBOX";
    case TodoBucket.TODO_BUCKET_TOMORROW:
      return "TODO_BUCKET_TOMORROW";
    case TodoBucket.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Todo {
  id: string;
  household_id?: string | undefined;
  owner_id: string;
  title: string;
  /** See enum-like string sets above. */
  status: string;
  priority: string;
  due_at?: string | undefined;
  due_date_only: boolean;
  snoozed_until?:
    | string
    | undefined;
  /** Plugin id that originated this todo, e.g. "manual", "maintenance". */
  source_plugin: string;
  /** Plugin-scoped type, e.g. "maintenance.service_call". */
  type_tag: string;
  description?:
    | string
    | undefined;
  /** Opaque, plugin-structured. Validated against the TodoType's context_schema. */
  context_blob?: { [key: string]: any } | undefined;
  context_version: number;
  /** RFC 5545 RRULE, or empty. */
  recurrence_rule: string;
  vanishing_enabled: boolean;
  /** HH:MM 24h, daily boundary. */
  vanish_at_time: string;
  notify_enabled: boolean;
  /** Milliseconds before due_at. */
  notify_before: string;
  project_id?:
    | string
    | undefined;
  /** "" | "completed" | "vanished" | "blocked" — immutable once set. */
  close_reason: string;
  created_at?: string | undefined;
  updated_at?: string | undefined;
  completed_at?: string | undefined;
  deleted_at?:
    | string
    | undefined;
  /**
   * Handler-enriched, response-only fields (not persisted on Todo):
   * set on list/detail responses where the backend has joined extra data.
   */
  project_title?:
    | string
    | undefined;
  /**
   * Manual sort order within the todo's section. Unset = natural key.
   * See domain.Todo.SortOrder for semantics.
   */
  sort_order?: number | undefined;
  visibility: string;
  /**
   * Smart-input bookkeeping. NULL on todos that didn't come through the
   * smart-input flow.
   *
   * original_prompt is the raw user-typed natural-language text that
   * produced this todo (e.g. "Change towel every sunday"). Persisted so
   * the durable LLM enhancement workflow can run and retry without
   * depending on in-memory state, and so the UI can re-enhance later.
   */
  original_prompt?:
    | string
    | undefined;
  /**
   * enhancement_status is "pending" | "completed" | "failed" | "skipped"
   * while the Temporal LLM enhancement workflow is in flight, completed,
   * failed-after-retries, or deliberately skipped because the user
   * hand-edited the row before enhancement landed (edit wins; see the
   * all-or-nothing guard in RunEnhancement). Lets the UI show an
   * "enhancing…" affordance and surfaces failure to operators.
   */
  enhancement_status?:
    | string
    | undefined;
  /**
   * Temporal workflow id for in-flight title-rewording of a blocked
   * follow-up. Empty when no enhancement is running.
   */
  enhance_workflow_id?:
    | string
    | undefined;
  /**
   * The user-intended due date, captured before auto-move starts
   * rewriting due_at forward day-by-day. NULL until auto-move first
   * bumps due_at; once set, stays put so the row can render
   * "Overdue • <real original date>" instead of today's auto-moved
   * value. User-initiated updates to due_at clear this back to NULL
   * (the user is re-stating the intent).
   */
  original_due_at?:
    | string
    | undefined;
  /**
   * Free-form, household-wide labels (tag NAMES). Replace-set on write:
   * CreateTodoRequest.tags and UpdateTodoRequest.fields["tags"] each carry
   * the full desired set. grdb-skipped — the iOS sidecar ignores it for now
   * (tag UI is a later phase); same treatment as Contact.handles.
   */
  tags: string[];
  /**
   * Stable identifier shared by every instance of a recurring series. A
   * recurring todo is created with series_id = its own id; each spawned
   * successor copies it forward, giving external consumers (the Home
   * Assistant complete button) a durable handle that survives the
   * new-row-per-completion spawn. NULL on non-recurring and legacy rows;
   * effective series id is then the row id. grdb-skipped — server-internal,
   * never delta-synced to clients.
   */
  series_id?: string | undefined;
}

/**
 * TodoCompletion is a materialized row written at completion time and
 * preserved separately so recurring todos keep history.
 */
export interface TodoCompletion {
  id: string;
  todo_id: string;
  owner_id: string;
  title: string;
  description?: string | undefined;
  priority: string;
  due_at?: string | undefined;
  due_date_only: boolean;
  close_reason: string;
  completed_at?: string | undefined;
  recurrence_rule: string;
  created_at?:
    | string
    | undefined;
  /**
   * Server-owned: true iff this row can be flipped vanished -> completed
   * right now. Currently `close_reason == "vanished"` and within the 7-day
   * grace window. Clients render the "Mark completed" affordance from this
   * flag; the same rule is enforced by UpdateCompletionCloseReason so the
   * server stays authoritative even if a stale client posts after the window.
   */
  can_mark_completed: boolean;
  /**
   * Who actually pressed done. Equals owner_id when the owner closed
   * their own row; differs on cross-member completion (a household
   * sibling completed the row on the owner's behalf). The Log surfaces
   * the completion to BOTH users — the owner sees "Completed by <Eugenia>"
   * and the completer sees it in their own log.
   */
  completed_by_id: string;
  /**
   * Drives the iOS delta-sync cursor on SyncPullCompletions. Server stamps
   * it on every write; advances on close-reason flips and soft-deletes.
   */
  updated_at?:
    | string
    | undefined;
  /**
   * Soft-delete tombstone — set when the parent todo is deleted. iOS pulls
   * these via SyncPullCompletions and drops the local row.
   */
  deleted_at?:
    | string
    | undefined;
  /**
   * Set when close_reason=='blocked'; references the auto-created
   * follow-up Todo.server_id. ON DELETE SET NULL — historical row remains
   * with a dangling pointer cleared if the follow-up is later deleted.
   */
  blocked_followup_id?: string | undefined;
}

export interface CreateTodoRequest {
  title: string;
  owner_id?:
    | string
    | undefined;
  /** Default "manual" on the backend. */
  source_plugin?: string | undefined;
  type_tag?: string | undefined;
  priority?: string | undefined;
  due_at?: string | undefined;
  due_date_only?: boolean | undefined;
  context_blob?: { [key: string]: any } | undefined;
  description?: string | undefined;
  vanishing_enabled?: boolean | undefined;
  vanish_at_time?: string | undefined;
  recurrence_rule?: string | undefined;
  notify_enabled?: boolean | undefined;
  notify_before?: string | undefined;
  project_id?: string | undefined;
  visibility?:
    | string
    | undefined;
  /** Full desired tag set (tag NAMES) for the new todo. Replace-set. */
  tags: string[];
}

/**
 * Free-form bag: the backend accepts arbitrary field updates.
 * Represented as a google.protobuf.Struct to stay faithful to the
 * current "PATCH any subset" semantics.
 */
export interface UpdateTodoRequest {
  fields?:
    | { [key: string]: any }
    | undefined;
  /** Default UNSPECIFIED → SERIES. INSTANCE only meaningful for recurring. */
  scope: RecurringScope;
}

export interface SmartTodoRequest {
  text: string;
  timezone: string;
  /**
   * client_id is the client-authored UUID for the row this request will
   * create. The server uses it verbatim as the todo id (idempotently: a
   * repeat with the same client_id returns the existing row rather than
   * forking a duplicate). It is the SAME id the client uses for its
   * optimistic local row and for the offline-fallback create that ships
   * via sync/push when the smart response is lost on the wire — so all
   * three channels collapse onto one id and enhancement updates it in
   * place. Empty → server mints the id (legacy clients).
   */
  client_id: string;
}

/**
 * SmartTodoResponse is the envelope returned by POST /api/v1/todos/smart
 * for every smart-todo outcome.
 *
 * action: "created" | "deleted" | "completed" | "updated"
 *
 * The `todo` field carries the full post-write Todo for "created",
 * "completed", and "updated" so the web saga can replay the delta via
 * replaceTodo/addTodo without a FETCH_TODOS hammer. For "deleted",
 * `deleted_todo_id` carries the affected id (todo body is absent). The
 * `completed_todo_id` / `updated_todo_id` ids and `updated_fields` are
 * kept alongside `todo` as a convenience for clients that want to log
 * the diff without re-deriving it.
 */
export interface SmartTodoResponse {
  action: string;
  /** Present when action is "deleted". */
  deleted_todo_id?:
    | string
    | undefined;
  /** Present when action is "completed". `todo` carries the full row. */
  completed_todo_id?: string | undefined;
  completed_at?:
    | string
    | undefined;
  /** Present when action is "updated". `todo` carries the full post-update row. */
  updated_todo_id?: string | undefined;
  updated_fields: string[];
  /**
   * Full post-write Todo. Populated on "created", "completed", and
   * "updated"; absent on "deleted". For multi-instance series the
   * server still stuffs todos[0] here for clients that haven't
   * migrated to the `todos` list — newer clients prefer `todos`.
   */
  todo?:
    | Todo
    | undefined;
  /**
   * Series fan-out: when the user types "create 3 daily series ...",
   * the server creates N rows and returns them all so the saga can
   * dispatch addTodo per element (pext full-delta, no per-row WS).
   * Length ≥ 1 for "created" actions; empty for "deleted" and the
   * other action types that don't materialize new rows.
   */
  todos: Todo[];
}

export interface SnoozeRequest {
  duration_hours?: number | undefined;
  until?: string | undefined;
}

export interface CompleteRequest {
  completed_at?: string | undefined;
}

export interface ScheduleCompleteResponse {
  workflow_id: string;
}

export interface UpdateCompletionRequest {
  /** "completed" | "vanished" */
  close_reason: string;
}

export interface TodoListResponse {
  items: Todo[];
  pagination?: PaginationMeta | undefined;
}

export interface TodoCompletionListResponse {
  items: TodoCompletion[];
  pagination?: PaginationMeta | undefined;
}

/** Response for ListTags: every household tag name, sorted ascending. */
export interface TagListResponse {
  tags: string[];
}

export interface BriefItem {
  id: string;
  title: string;
  status: string;
  owner?: User | undefined;
  type_tag?: string | undefined;
  context_blob?: { [key: string]: any } | undefined;
  due_at?: string | undefined;
  source_plugin: string;
}

export interface BriefSection {
  /** "OVERDUE" | "TIME_SENSITIVE" | "TODAY" | "UPCOMING" */
  name: string;
  items: BriefItem[];
}

export interface BriefResponse {
  /** ISO date, e.g. "2026-04-17" */
  date: string;
  sections: BriefSection[];
}

export interface ListCompletionsRequest {
  /**
   * Embedded pagination is preserved for wire compatibility. The
   * family-http binder does NOT recurse into nested message fields
   * when overlaying ?query params, so callers MUST use the top-level
   * limit / offset / page below — neither web nor iOS ever
   * successfully populated `pagination` from a query string. See
   * handler precedence: `offset` > `page` > `pagination.page` > 0.
   */
  pagination?: PaginationRequest | undefined;
  limit: number;
  offset: number;
  page: number;
  /**
   * Optional case-insensitive substring filter applied to title and
   * description. Empty string = no filter (current behavior).
   */
  q: string;
}

export interface UpdateCompletionPathRequest {
  id: string;
  /** "completed" | "vanished" */
  close_reason: string;
}

export interface GetTodoRequest {
  id: string;
}

export interface ListTodosRequest {
  status?: string | undefined;
  project_id?: string | undefined;
  pagination?: PaginationRequest | undefined;
}

export interface UpdateTodoPathRequest {
  id: string;
  fields?: { [key: string]: any } | undefined;
  scope: RecurringScope;
  /**
   * Optional client-chosen UUID. When set on an INSTANCE-scope edit of a
   * recurring todo, the server uses this verbatim as the forked clone's
   * `id`. Mirrors MarkBlockedTodoRequest.client_followup_id: lets
   * offline-first iOS pre-create the clone row locally with its final
   * server_id before queueing the outbox op, and is idempotent on retry
   * (a second request with the same value re-fetches the existing clone
   * instead of forking a second time).
   */
  client_clone_id?: string | undefined;
}

/**
 * Response from UpdateTodo. The wrapper is needed because an INSTANCE-scope
 * edit of a recurring todo mutates two rows: a fresh non-recurring clone
 * carrying the user's edits, and the original series row whose due_at
 * advances to the next occurrence. SERIES and non-recurring updates only
 * populate `todo` (advanced_series stays unset).
 */
export interface UpdateTodoResponse {
  /**
   * Primary row the caller acted on: the clone for INSTANCE-scope on a
   * recurring todo; the updated row otherwise.
   */
  todo?:
    | Todo
    | undefined;
  /**
   * The series row with its advanced due_at. Set only on INSTANCE-scope
   * edits of a recurring todo; unset otherwise.
   */
  advanced_series?: Todo | undefined;
}

export interface DeleteTodoRequest {
  id: string;
}

export interface CompleteTodoRequest {
  id: string;
  completed_at?:
    | string
    | undefined;
  /**
   * Client-authored UUID for the resulting todo_completions row. When set,
   * the server reuses it as the completion's primary key so outbox retries /
   * double-taps are idempotent (ON CONFLICT (id) DO NOTHING at the repo).
   * Empty → server generates a UUID (legacy behavior). Validated as a UUID.
   */
  client_completion_id?: string | undefined;
}

/** RecurringSeriesSummary is the open instance of one recurring series. */
export interface RecurringSeriesSummary {
  /**
   * Stable series handle (effective series id of the open instance). Bind a
   * Home Assistant button to this, not to a todo id.
   */
  series_id: string;
  title: string;
  recurrence_rule: string;
  current_due_at?: string | undefined;
}

export interface RecurringSeriesListResponse {
  series: RecurringSeriesSummary[];
}

export interface CompleteCurrentInSeriesRequest {
  series_id: string;
  /**
   * Deterministic per-day id minted by the client (HA button) so repeat /
   * near-concurrent presses on the same local day collapse to one completion.
   * Empty → server generates one. Validated as a UUID when set.
   */
  client_completion_id?: string | undefined;
}

export interface CompleteCurrentInSeriesResponse {
  /**
   * false when nothing was due (already done today, or next not yet due) — a
   * safe no-op, not an error.
   */
  completed: boolean;
  completed_todo?:
    | Todo
    | undefined;
  /** The spawned next occurrence, when the completion advanced the series. */
  next_todo?: Todo | undefined;
}

export interface ScheduleCompleteTodoRequest {
  id: string;
  completed_at?:
    | string
    | undefined;
  /**
   * See CompleteTodoRequest.client_completion_id. Threaded through the
   * Temporal CompleteTodoWorkflow so the delayed completion reuses the
   * same client-chosen UUID.
   */
  client_completion_id?: string | undefined;
}

export interface CancelScheduledCompleteTodoRequest {
  id: string;
}

export interface SnoozeTodoRequest {
  id: string;
  duration_hours?: number | undefined;
  until?: string | undefined;
}

export interface SkipTodoRequest {
  id: string;
}

export interface ClaimTodoRequest {
  id: string;
  new_owner_id: string;
  scope: RecurringScope;
}

export interface MoveTodoRequest {
  id: string;
  bucket: TodoBucket;
  /**
   * IANA timezone, e.g. "America/New_York". Required — server can't
   * compute "end of today" without it.
   */
  timezone: string;
}

/**
 * Request to MarkBlockedTodo. Carries the original todo's id (from the
 * path) and optional client-chosen UUIDs for the follow-up todo and the
 * completion log row. When the client supplies them, the server uses
 * them verbatim — letting offline-first clients (iOS) pre-create the
 * rows locally with their final server_ids and queue the API call in
 * the outbox without needing post-drain reconciliation. Idempotency on
 * retry is keyed off `client_followup_id`: a second request with the
 * same value re-fetches the existing rows instead of erroring.
 */
export interface MarkBlockedTodoRequest {
  id: string;
  client_followup_id?: string | undefined;
  client_completion_id?: string | undefined;
}

/**
 * Response from MarkBlockedTodo. The follow-up todo's title starts as
 * the mechanical core.FollowupTitle(original) — "Follow up: X" for a
 * first block, "Follow up (2): X" / "Follow up (3): X" / ... when the
 * original is already a follow-up; the registered Temporal workflow
 * (workflow_id) will rewrite it asynchronously to a clear imperative.
 * Clients can either re-pull the follow-up later or accept the
 * mechanical title and let the async update arrive via /sync/pull.
 */
export interface MarkBlockedTodoResponse {
  followup?: Todo | undefined;
  workflow_id: string;
  /**
   * The lead-time the server actually used when computing the
   * follow-up due_at — read from system_config.blocked_followup_working_days
   * at request time. The toast renders this directly so the client
   * doesn't have to back-derive it from due_at (which gets off-by-one
   * around the Sat/Sun snap-forward).
   */
  working_days: number;
  /**
   * The original todo after it was flipped to status=done +
   * close_reason="blocked". Carried in the response so the saga can
   * dispatch a full state update without waiting for the WS broadcast.
   */
  original?:
    | Todo
    | undefined;
  /**
   * The completion-log row written for the original. Lets the saga
   * surface the entry in CompletionLog immediately.
   */
  completion?: TodoCompletion | undefined;
}

/**
 * Request to UnblockTodo. Carries the original todo's id (from the
 * path); the server looks up the blocked completion + follow-up via
 * the completion log link (blocked_followup_id) so the client only
 * needs to know the original.
 */
export interface UnblockTodoRequest {
  id: string;
}

/**
 * Response from UnblockTodo. already_unblocked=true means there was no
 * blocked completion for the supplied id when the call ran (already
 * undone, or never blocked) — a no-op from the server's perspective.
 * Used by the UI to distinguish "we just unblocked it" from "it was
 * already in the right state" without surfacing an error.
 */
export interface UnblockTodoResponse {
  already_unblocked: boolean;
  /**
   * The original todo after being restored to status=pending,
   * close_reason="". Saga uses this to update the local store
   * without waiting for a WS broadcast or a refetch.
   */
  original?:
    | Todo
    | undefined;
  /**
   * The follow-up todo's server id, so the saga can remove it from
   * the local todos byId / allIds maps immediately.
   */
  followup_id: string;
  /**
   * The completion-log row id that got tombstoned. Saga uses it to
   * drop the row from any cached log view.
   */
  completion_id: string;
}

export interface TodoDelta {
  /** Empty on first-time create; iOS fills in on updates/deletes. */
  server_id: string;
  /**
   * Opaque iOS-side dedup key — echoed back in push response so iOS
   * can stamp server_id on the local row.
   */
  client_local_id: string;
  action: TodoDelta_Action;
  /** Full Todo payload on UPSERT; only id fields on DELETE. */
  todo?:
    | Todo
    | undefined;
  /** iOS-side updated_at used for LWW tiebreak against server's current row. */
  client_updated_at?: string | undefined;
}

export enum TodoDelta_Action {
  ACTION_UNSPECIFIED = 0,
  ACTION_UPSERT = 1,
  ACTION_DELETE = 2,
  UNRECOGNIZED = -1,
}

export function todoDelta_ActionFromJSON(object: any): TodoDelta_Action {
  switch (object) {
    case 0:
    case "ACTION_UNSPECIFIED":
      return TodoDelta_Action.ACTION_UNSPECIFIED;
    case 1:
    case "ACTION_UPSERT":
      return TodoDelta_Action.ACTION_UPSERT;
    case 2:
    case "ACTION_DELETE":
      return TodoDelta_Action.ACTION_DELETE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TodoDelta_Action.UNRECOGNIZED;
  }
}

export function todoDelta_ActionToJSON(object: TodoDelta_Action): string {
  switch (object) {
    case TodoDelta_Action.ACTION_UNSPECIFIED:
      return "ACTION_UNSPECIFIED";
    case TodoDelta_Action.ACTION_UPSERT:
      return "ACTION_UPSERT";
    case TodoDelta_Action.ACTION_DELETE:
      return "ACTION_DELETE";
    case TodoDelta_Action.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface TodoSyncPushRequest {
  deltas: TodoDelta[];
}

export interface TodoSyncPushResponse {
  /** One per accepted UPSERT so iOS can learn the server_id for new rows. */
  mappings: TodoSyncPushResponse_IdMapping[];
  /**
   * client_local_ids the server refused because its row is newer; iOS
   * must pull and reconcile before retrying these.
   */
  rejected_client_ids: string[];
}

export interface TodoSyncPushResponse_IdMapping {
  client_local_id: string;
  server_id: string;
}

export interface TodoSyncPullRequest {
  /** Server returns rows with updated_at > since. Empty/zero = first pull. */
  since?: string | undefined;
  limit: number;
}

export interface TodoSyncPullResponse {
  /** Includes soft-deleted rows so iOS can apply tombstones. */
  todos: Todo[];
  /** max(updated_at) of this batch; iOS persists as the next `since`. */
  cursor?: string | undefined;
  has_more: boolean;
}

export interface TodoCompletionSyncPullRequest {
  /**
   * Server returns rows with (updated_at, id) > (since, since_id), ordered
   * by (updated_at ASC, id ASC). Empty/zero `since` = first pull from
   * epoch. Empty `since_id` = no tie-break (first pull, or boundary not
   * yet seen). Composite cursor avoids skipping rows that share an
   * updated_at on a page boundary; pre-v0.1.31 the strict `>` on
   * updated_at silently dropped tied rows when limit landed mid-tie.
   */
  since?: string | undefined;
  limit: number;
  since_id: string;
}

export interface TodoCompletionSyncPullResponse {
  /** Includes soft-deleted rows so iOS can apply tombstones. */
  items: TodoCompletion[];
  /** max(updated_at) of this batch; iOS persists as the next `since`. */
  cursor?: string | undefined;
  has_more: boolean;
  /**
   * ID of the last row in `items` under the SQL ordering (updated_at ASC,
   * id ASC). iOS persists alongside `cursor` and echoes via `since_id`
   * on the next pull so tied rows are not dropped at a page boundary.
   * Empty when `items` is empty.
   */
  cursor_id: string;
}

function createBaseTodo(): Todo {
  return {
    id: "",
    household_id: undefined,
    owner_id: "",
    title: "",
    status: "",
    priority: "",
    due_at: undefined,
    due_date_only: false,
    snoozed_until: undefined,
    source_plugin: "",
    type_tag: "",
    description: undefined,
    context_blob: undefined,
    context_version: 0,
    recurrence_rule: "",
    vanishing_enabled: false,
    vanish_at_time: "",
    notify_enabled: false,
    notify_before: "0",
    project_id: undefined,
    close_reason: "",
    created_at: undefined,
    updated_at: undefined,
    completed_at: undefined,
    deleted_at: undefined,
    project_title: undefined,
    sort_order: undefined,
    visibility: "",
    original_prompt: undefined,
    enhancement_status: undefined,
    enhance_workflow_id: undefined,
    original_due_at: undefined,
    tags: [],
    series_id: undefined,
  };
}

export const Todo: MessageFns<Todo> = {
  encode(message: Todo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.household_id !== undefined) {
      writer.uint32(18).string(message.household_id);
    }
    if (message.owner_id !== "") {
      writer.uint32(26).string(message.owner_id);
    }
    if (message.title !== "") {
      writer.uint32(34).string(message.title);
    }
    if (message.status !== "") {
      writer.uint32(42).string(message.status);
    }
    if (message.priority !== "") {
      writer.uint32(50).string(message.priority);
    }
    if (message.due_at !== undefined) {
      Timestamp.encode(toTimestamp(message.due_at), writer.uint32(58).fork()).join();
    }
    if (message.due_date_only !== false) {
      writer.uint32(64).bool(message.due_date_only);
    }
    if (message.snoozed_until !== undefined) {
      Timestamp.encode(toTimestamp(message.snoozed_until), writer.uint32(74).fork()).join();
    }
    if (message.source_plugin !== "") {
      writer.uint32(82).string(message.source_plugin);
    }
    if (message.type_tag !== "") {
      writer.uint32(90).string(message.type_tag);
    }
    if (message.description !== undefined) {
      writer.uint32(98).string(message.description);
    }
    if (message.context_blob !== undefined) {
      Struct.encode(Struct.wrap(message.context_blob), writer.uint32(106).fork()).join();
    }
    if (message.context_version !== 0) {
      writer.uint32(112).int32(message.context_version);
    }
    if (message.recurrence_rule !== "") {
      writer.uint32(122).string(message.recurrence_rule);
    }
    if (message.vanishing_enabled !== false) {
      writer.uint32(128).bool(message.vanishing_enabled);
    }
    if (message.vanish_at_time !== "") {
      writer.uint32(138).string(message.vanish_at_time);
    }
    if (message.notify_enabled !== false) {
      writer.uint32(144).bool(message.notify_enabled);
    }
    if (message.notify_before !== "0") {
      writer.uint32(152).int64(message.notify_before);
    }
    if (message.project_id !== undefined) {
      writer.uint32(162).string(message.project_id);
    }
    if (message.close_reason !== "") {
      writer.uint32(170).string(message.close_reason);
    }
    if (message.created_at !== undefined) {
      Timestamp.encode(toTimestamp(message.created_at), writer.uint32(178).fork()).join();
    }
    if (message.updated_at !== undefined) {
      Timestamp.encode(toTimestamp(message.updated_at), writer.uint32(186).fork()).join();
    }
    if (message.completed_at !== undefined) {
      Timestamp.encode(toTimestamp(message.completed_at), writer.uint32(194).fork()).join();
    }
    if (message.deleted_at !== undefined) {
      Timestamp.encode(toTimestamp(message.deleted_at), writer.uint32(202).fork()).join();
    }
    if (message.project_title !== undefined) {
      writer.uint32(210).string(message.project_title);
    }
    if (message.sort_order !== undefined) {
      writer.uint32(217).double(message.sort_order);
    }
    if (message.visibility !== "") {
      writer.uint32(226).string(message.visibility);
    }
    if (message.original_prompt !== undefined) {
      writer.uint32(234).string(message.original_prompt);
    }
    if (message.enhancement_status !== undefined) {
      writer.uint32(242).string(message.enhancement_status);
    }
    if (message.enhance_workflow_id !== undefined) {
      writer.uint32(250).string(message.enhance_workflow_id);
    }
    if (message.original_due_at !== undefined) {
      Timestamp.encode(toTimestamp(message.original_due_at), writer.uint32(258).fork()).join();
    }
    for (const v of message.tags) {
      writer.uint32(266).string(v!);
    }
    if (message.series_id !== undefined) {
      writer.uint32(274).string(message.series_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Todo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTodo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.household_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.owner_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.priority = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.due_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.due_date_only = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.snoozed_until = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.source_plugin = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.type_tag = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.context_blob = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.context_version = reader.int32();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.recurrence_rule = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.vanishing_enabled = reader.bool();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.vanish_at_time = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.notify_enabled = reader.bool();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.notify_before = reader.int64().toString();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.project_id = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.close_reason = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.created_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.updated_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.completed_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.deleted_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.project_title = reader.string();
          continue;
        }
        case 27: {
          if (tag !== 217) {
            break;
          }

          message.sort_order = reader.double();
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.visibility = reader.string();
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.original_prompt = reader.string();
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.enhancement_status = reader.string();
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.enhance_workflow_id = reader.string();
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.original_due_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.tags.push(reader.string());
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.series_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Todo {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      household_id: isSet(object.household_id) ? globalThis.String(object.household_id) : undefined,
      owner_id: isSet(object.owner_id) ? globalThis.String(object.owner_id) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      priority: isSet(object.priority) ? globalThis.String(object.priority) : "",
      due_at: isSet(object.due_at) ? globalThis.String(object.due_at) : undefined,
      due_date_only: isSet(object.due_date_only) ? globalThis.Boolean(object.due_date_only) : false,
      snoozed_until: isSet(object.snoozed_until) ? globalThis.String(object.snoozed_until) : undefined,
      source_plugin: isSet(object.source_plugin) ? globalThis.String(object.source_plugin) : "",
      type_tag: isSet(object.type_tag) ? globalThis.String(object.type_tag) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      context_blob: isObject(object.context_blob) ? object.context_blob : undefined,
      context_version: isSet(object.context_version) ? globalThis.Number(object.context_version) : 0,
      recurrence_rule: isSet(object.recurrence_rule) ? globalThis.String(object.recurrence_rule) : "",
      vanishing_enabled: isSet(object.vanishing_enabled) ? globalThis.Boolean(object.vanishing_enabled) : false,
      vanish_at_time: isSet(object.vanish_at_time) ? globalThis.String(object.vanish_at_time) : "",
      notify_enabled: isSet(object.notify_enabled) ? globalThis.Boolean(object.notify_enabled) : false,
      notify_before: isSet(object.notify_before) ? globalThis.String(object.notify_before) : "0",
      project_id: isSet(object.project_id) ? globalThis.String(object.project_id) : undefined,
      close_reason: isSet(object.close_reason) ? globalThis.String(object.close_reason) : "",
      created_at: isSet(object.created_at) ? globalThis.String(object.created_at) : undefined,
      updated_at: isSet(object.updated_at) ? globalThis.String(object.updated_at) : undefined,
      completed_at: isSet(object.completed_at) ? globalThis.String(object.completed_at) : undefined,
      deleted_at: isSet(object.deleted_at) ? globalThis.String(object.deleted_at) : undefined,
      project_title: isSet(object.project_title) ? globalThis.String(object.project_title) : undefined,
      sort_order: isSet(object.sort_order) ? globalThis.Number(object.sort_order) : undefined,
      visibility: isSet(object.visibility) ? globalThis.String(object.visibility) : "",
      original_prompt: isSet(object.original_prompt) ? globalThis.String(object.original_prompt) : undefined,
      enhancement_status: isSet(object.enhancement_status) ? globalThis.String(object.enhancement_status) : undefined,
      enhance_workflow_id: isSet(object.enhance_workflow_id)
        ? globalThis.String(object.enhance_workflow_id)
        : undefined,
      original_due_at: isSet(object.original_due_at) ? globalThis.String(object.original_due_at) : undefined,
      tags: globalThis.Array.isArray(object?.tags) ? object.tags.map((e: any) => globalThis.String(e)) : [],
      series_id: isSet(object.series_id) ? globalThis.String(object.series_id) : undefined,
    };
  },

  toJSON(message: Todo): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.household_id !== undefined) {
      obj.household_id = message.household_id;
    }
    if (message.owner_id !== "") {
      obj.owner_id = message.owner_id;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.priority !== "") {
      obj.priority = message.priority;
    }
    if (message.due_at !== undefined) {
      obj.due_at = message.due_at;
    }
    if (message.due_date_only !== false) {
      obj.due_date_only = message.due_date_only;
    }
    if (message.snoozed_until !== undefined) {
      obj.snoozed_until = message.snoozed_until;
    }
    if (message.source_plugin !== "") {
      obj.source_plugin = message.source_plugin;
    }
    if (message.type_tag !== "") {
      obj.type_tag = message.type_tag;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.context_blob !== undefined) {
      obj.context_blob = message.context_blob;
    }
    if (message.context_version !== 0) {
      obj.context_version = Math.round(message.context_version);
    }
    if (message.recurrence_rule !== "") {
      obj.recurrence_rule = message.recurrence_rule;
    }
    if (message.vanishing_enabled !== false) {
      obj.vanishing_enabled = message.vanishing_enabled;
    }
    if (message.vanish_at_time !== "") {
      obj.vanish_at_time = message.vanish_at_time;
    }
    if (message.notify_enabled !== false) {
      obj.notify_enabled = message.notify_enabled;
    }
    if (message.notify_before !== "0") {
      obj.notify_before = message.notify_before;
    }
    if (message.project_id !== undefined) {
      obj.project_id = message.project_id;
    }
    if (message.close_reason !== "") {
      obj.close_reason = message.close_reason;
    }
    if (message.created_at !== undefined) {
      obj.created_at = message.created_at;
    }
    if (message.updated_at !== undefined) {
      obj.updated_at = message.updated_at;
    }
    if (message.completed_at !== undefined) {
      obj.completed_at = message.completed_at;
    }
    if (message.deleted_at !== undefined) {
      obj.deleted_at = message.deleted_at;
    }
    if (message.project_title !== undefined) {
      obj.project_title = message.project_title;
    }
    if (message.sort_order !== undefined) {
      obj.sort_order = message.sort_order;
    }
    if (message.visibility !== "") {
      obj.visibility = message.visibility;
    }
    if (message.original_prompt !== undefined) {
      obj.original_prompt = message.original_prompt;
    }
    if (message.enhancement_status !== undefined) {
      obj.enhancement_status = message.enhancement_status;
    }
    if (message.enhance_workflow_id !== undefined) {
      obj.enhance_workflow_id = message.enhance_workflow_id;
    }
    if (message.original_due_at !== undefined) {
      obj.original_due_at = message.original_due_at;
    }
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    if (message.series_id !== undefined) {
      obj.series_id = message.series_id;
    }
    return obj;
  },

  create(base?: DeepPartial<Todo>): Todo {
    return Todo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Todo>): Todo {
    const message = createBaseTodo();
    message.id = object.id ?? "";
    message.household_id = object.household_id ?? undefined;
    message.owner_id = object.owner_id ?? "";
    message.title = object.title ?? "";
    message.status = object.status ?? "";
    message.priority = object.priority ?? "";
    message.due_at = object.due_at ?? undefined;
    message.due_date_only = object.due_date_only ?? false;
    message.snoozed_until = object.snoozed_until ?? undefined;
    message.source_plugin = object.source_plugin ?? "";
    message.type_tag = object.type_tag ?? "";
    message.description = object.description ?? undefined;
    message.context_blob = object.context_blob ?? undefined;
    message.context_version = object.context_version ?? 0;
    message.recurrence_rule = object.recurrence_rule ?? "";
    message.vanishing_enabled = object.vanishing_enabled ?? false;
    message.vanish_at_time = object.vanish_at_time ?? "";
    message.notify_enabled = object.notify_enabled ?? false;
    message.notify_before = object.notify_before ?? "0";
    message.project_id = object.project_id ?? undefined;
    message.close_reason = object.close_reason ?? "";
    message.created_at = object.created_at ?? undefined;
    message.updated_at = object.updated_at ?? undefined;
    message.completed_at = object.completed_at ?? undefined;
    message.deleted_at = object.deleted_at ?? undefined;
    message.project_title = object.project_title ?? undefined;
    message.sort_order = object.sort_order ?? undefined;
    message.visibility = object.visibility ?? "";
    message.original_prompt = object.original_prompt ?? undefined;
    message.enhancement_status = object.enhancement_status ?? undefined;
    message.enhance_workflow_id = object.enhance_workflow_id ?? undefined;
    message.original_due_at = object.original_due_at ?? undefined;
    message.tags = object.tags?.map((e) => e) || [];
    message.series_id = object.series_id ?? undefined;
    return message;
  },
};

function createBaseTodoCompletion(): TodoCompletion {
  return {
    id: "",
    todo_id: "",
    owner_id: "",
    title: "",
    description: undefined,
    priority: "",
    due_at: undefined,
    due_date_only: false,
    close_reason: "",
    completed_at: undefined,
    recurrence_rule: "",
    created_at: undefined,
    can_mark_completed: false,
    completed_by_id: "",
    updated_at: undefined,
    deleted_at: undefined,
    blocked_followup_id: undefined,
  };
}

export const TodoCompletion: MessageFns<TodoCompletion> = {
  encode(message: TodoCompletion, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.todo_id !== "") {
      writer.uint32(18).string(message.todo_id);
    }
    if (message.owner_id !== "") {
      writer.uint32(26).string(message.owner_id);
    }
    if (message.title !== "") {
      writer.uint32(34).string(message.title);
    }
    if (message.description !== undefined) {
      writer.uint32(42).string(message.description);
    }
    if (message.priority !== "") {
      writer.uint32(50).string(message.priority);
    }
    if (message.due_at !== undefined) {
      Timestamp.encode(toTimestamp(message.due_at), writer.uint32(58).fork()).join();
    }
    if (message.due_date_only !== false) {
      writer.uint32(64).bool(message.due_date_only);
    }
    if (message.close_reason !== "") {
      writer.uint32(74).string(message.close_reason);
    }
    if (message.completed_at !== undefined) {
      Timestamp.encode(toTimestamp(message.completed_at), writer.uint32(82).fork()).join();
    }
    if (message.recurrence_rule !== "") {
      writer.uint32(90).string(message.recurrence_rule);
    }
    if (message.created_at !== undefined) {
      Timestamp.encode(toTimestamp(message.created_at), writer.uint32(98).fork()).join();
    }
    if (message.can_mark_completed !== false) {
      writer.uint32(104).bool(message.can_mark_completed);
    }
    if (message.completed_by_id !== "") {
      writer.uint32(114).string(message.completed_by_id);
    }
    if (message.updated_at !== undefined) {
      Timestamp.encode(toTimestamp(message.updated_at), writer.uint32(122).fork()).join();
    }
    if (message.deleted_at !== undefined) {
      Timestamp.encode(toTimestamp(message.deleted_at), writer.uint32(130).fork()).join();
    }
    if (message.blocked_followup_id !== undefined) {
      writer.uint32(138).string(message.blocked_followup_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TodoCompletion {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTodoCompletion();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.todo_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.owner_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.priority = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.due_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.due_date_only = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.close_reason = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.completed_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.recurrence_rule = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.created_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.can_mark_completed = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.completed_by_id = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.updated_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.deleted_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.blocked_followup_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TodoCompletion {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      todo_id: isSet(object.todo_id) ? globalThis.String(object.todo_id) : "",
      owner_id: isSet(object.owner_id) ? globalThis.String(object.owner_id) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      priority: isSet(object.priority) ? globalThis.String(object.priority) : "",
      due_at: isSet(object.due_at) ? globalThis.String(object.due_at) : undefined,
      due_date_only: isSet(object.due_date_only) ? globalThis.Boolean(object.due_date_only) : false,
      close_reason: isSet(object.close_reason) ? globalThis.String(object.close_reason) : "",
      completed_at: isSet(object.completed_at) ? globalThis.String(object.completed_at) : undefined,
      recurrence_rule: isSet(object.recurrence_rule) ? globalThis.String(object.recurrence_rule) : "",
      created_at: isSet(object.created_at) ? globalThis.String(object.created_at) : undefined,
      can_mark_completed: isSet(object.can_mark_completed) ? globalThis.Boolean(object.can_mark_completed) : false,
      completed_by_id: isSet(object.completed_by_id) ? globalThis.String(object.completed_by_id) : "",
      updated_at: isSet(object.updated_at) ? globalThis.String(object.updated_at) : undefined,
      deleted_at: isSet(object.deleted_at) ? globalThis.String(object.deleted_at) : undefined,
      blocked_followup_id: isSet(object.blocked_followup_id)
        ? globalThis.String(object.blocked_followup_id)
        : undefined,
    };
  },

  toJSON(message: TodoCompletion): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.todo_id !== "") {
      obj.todo_id = message.todo_id;
    }
    if (message.owner_id !== "") {
      obj.owner_id = message.owner_id;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.priority !== "") {
      obj.priority = message.priority;
    }
    if (message.due_at !== undefined) {
      obj.due_at = message.due_at;
    }
    if (message.due_date_only !== false) {
      obj.due_date_only = message.due_date_only;
    }
    if (message.close_reason !== "") {
      obj.close_reason = message.close_reason;
    }
    if (message.completed_at !== undefined) {
      obj.completed_at = message.completed_at;
    }
    if (message.recurrence_rule !== "") {
      obj.recurrence_rule = message.recurrence_rule;
    }
    if (message.created_at !== undefined) {
      obj.created_at = message.created_at;
    }
    if (message.can_mark_completed !== false) {
      obj.can_mark_completed = message.can_mark_completed;
    }
    if (message.completed_by_id !== "") {
      obj.completed_by_id = message.completed_by_id;
    }
    if (message.updated_at !== undefined) {
      obj.updated_at = message.updated_at;
    }
    if (message.deleted_at !== undefined) {
      obj.deleted_at = message.deleted_at;
    }
    if (message.blocked_followup_id !== undefined) {
      obj.blocked_followup_id = message.blocked_followup_id;
    }
    return obj;
  },

  create(base?: DeepPartial<TodoCompletion>): TodoCompletion {
    return TodoCompletion.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TodoCompletion>): TodoCompletion {
    const message = createBaseTodoCompletion();
    message.id = object.id ?? "";
    message.todo_id = object.todo_id ?? "";
    message.owner_id = object.owner_id ?? "";
    message.title = object.title ?? "";
    message.description = object.description ?? undefined;
    message.priority = object.priority ?? "";
    message.due_at = object.due_at ?? undefined;
    message.due_date_only = object.due_date_only ?? false;
    message.close_reason = object.close_reason ?? "";
    message.completed_at = object.completed_at ?? undefined;
    message.recurrence_rule = object.recurrence_rule ?? "";
    message.created_at = object.created_at ?? undefined;
    message.can_mark_completed = object.can_mark_completed ?? false;
    message.completed_by_id = object.completed_by_id ?? "";
    message.updated_at = object.updated_at ?? undefined;
    message.deleted_at = object.deleted_at ?? undefined;
    message.blocked_followup_id = object.blocked_followup_id ?? undefined;
    return message;
  },
};

function createBaseCreateTodoRequest(): CreateTodoRequest {
  return {
    title: "",
    owner_id: undefined,
    source_plugin: undefined,
    type_tag: undefined,
    priority: undefined,
    due_at: undefined,
    due_date_only: undefined,
    context_blob: undefined,
    description: undefined,
    vanishing_enabled: undefined,
    vanish_at_time: undefined,
    recurrence_rule: undefined,
    notify_enabled: undefined,
    notify_before: undefined,
    project_id: undefined,
    visibility: undefined,
    tags: [],
  };
}

export const CreateTodoRequest: MessageFns<CreateTodoRequest> = {
  encode(message: CreateTodoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }
    if (message.owner_id !== undefined) {
      writer.uint32(18).string(message.owner_id);
    }
    if (message.source_plugin !== undefined) {
      writer.uint32(26).string(message.source_plugin);
    }
    if (message.type_tag !== undefined) {
      writer.uint32(34).string(message.type_tag);
    }
    if (message.priority !== undefined) {
      writer.uint32(42).string(message.priority);
    }
    if (message.due_at !== undefined) {
      Timestamp.encode(toTimestamp(message.due_at), writer.uint32(50).fork()).join();
    }
    if (message.due_date_only !== undefined) {
      writer.uint32(56).bool(message.due_date_only);
    }
    if (message.context_blob !== undefined) {
      Struct.encode(Struct.wrap(message.context_blob), writer.uint32(66).fork()).join();
    }
    if (message.description !== undefined) {
      writer.uint32(74).string(message.description);
    }
    if (message.vanishing_enabled !== undefined) {
      writer.uint32(80).bool(message.vanishing_enabled);
    }
    if (message.vanish_at_time !== undefined) {
      writer.uint32(90).string(message.vanish_at_time);
    }
    if (message.recurrence_rule !== undefined) {
      writer.uint32(98).string(message.recurrence_rule);
    }
    if (message.notify_enabled !== undefined) {
      writer.uint32(104).bool(message.notify_enabled);
    }
    if (message.notify_before !== undefined) {
      writer.uint32(112).int64(message.notify_before);
    }
    if (message.project_id !== undefined) {
      writer.uint32(122).string(message.project_id);
    }
    if (message.visibility !== undefined) {
      writer.uint32(130).string(message.visibility);
    }
    for (const v of message.tags) {
      writer.uint32(138).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateTodoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateTodoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.owner_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.source_plugin = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.type_tag = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.priority = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.due_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.due_date_only = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.context_blob = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.vanishing_enabled = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.vanish_at_time = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.recurrence_rule = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.notify_enabled = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.notify_before = reader.int64().toString();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.project_id = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.visibility = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.tags.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateTodoRequest {
    return {
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      owner_id: isSet(object.owner_id) ? globalThis.String(object.owner_id) : undefined,
      source_plugin: isSet(object.source_plugin) ? globalThis.String(object.source_plugin) : undefined,
      type_tag: isSet(object.type_tag) ? globalThis.String(object.type_tag) : undefined,
      priority: isSet(object.priority) ? globalThis.String(object.priority) : undefined,
      due_at: isSet(object.due_at) ? globalThis.String(object.due_at) : undefined,
      due_date_only: isSet(object.due_date_only) ? globalThis.Boolean(object.due_date_only) : undefined,
      context_blob: isObject(object.context_blob) ? object.context_blob : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      vanishing_enabled: isSet(object.vanishing_enabled) ? globalThis.Boolean(object.vanishing_enabled) : undefined,
      vanish_at_time: isSet(object.vanish_at_time) ? globalThis.String(object.vanish_at_time) : undefined,
      recurrence_rule: isSet(object.recurrence_rule) ? globalThis.String(object.recurrence_rule) : undefined,
      notify_enabled: isSet(object.notify_enabled) ? globalThis.Boolean(object.notify_enabled) : undefined,
      notify_before: isSet(object.notify_before) ? globalThis.String(object.notify_before) : undefined,
      project_id: isSet(object.project_id) ? globalThis.String(object.project_id) : undefined,
      visibility: isSet(object.visibility) ? globalThis.String(object.visibility) : undefined,
      tags: globalThis.Array.isArray(object?.tags) ? object.tags.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: CreateTodoRequest): unknown {
    const obj: any = {};
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.owner_id !== undefined) {
      obj.owner_id = message.owner_id;
    }
    if (message.source_plugin !== undefined) {
      obj.source_plugin = message.source_plugin;
    }
    if (message.type_tag !== undefined) {
      obj.type_tag = message.type_tag;
    }
    if (message.priority !== undefined) {
      obj.priority = message.priority;
    }
    if (message.due_at !== undefined) {
      obj.due_at = message.due_at;
    }
    if (message.due_date_only !== undefined) {
      obj.due_date_only = message.due_date_only;
    }
    if (message.context_blob !== undefined) {
      obj.context_blob = message.context_blob;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.vanishing_enabled !== undefined) {
      obj.vanishing_enabled = message.vanishing_enabled;
    }
    if (message.vanish_at_time !== undefined) {
      obj.vanish_at_time = message.vanish_at_time;
    }
    if (message.recurrence_rule !== undefined) {
      obj.recurrence_rule = message.recurrence_rule;
    }
    if (message.notify_enabled !== undefined) {
      obj.notify_enabled = message.notify_enabled;
    }
    if (message.notify_before !== undefined) {
      obj.notify_before = message.notify_before;
    }
    if (message.project_id !== undefined) {
      obj.project_id = message.project_id;
    }
    if (message.visibility !== undefined) {
      obj.visibility = message.visibility;
    }
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    return obj;
  },

  create(base?: DeepPartial<CreateTodoRequest>): CreateTodoRequest {
    return CreateTodoRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateTodoRequest>): CreateTodoRequest {
    const message = createBaseCreateTodoRequest();
    message.title = object.title ?? "";
    message.owner_id = object.owner_id ?? undefined;
    message.source_plugin = object.source_plugin ?? undefined;
    message.type_tag = object.type_tag ?? undefined;
    message.priority = object.priority ?? undefined;
    message.due_at = object.due_at ?? undefined;
    message.due_date_only = object.due_date_only ?? undefined;
    message.context_blob = object.context_blob ?? undefined;
    message.description = object.description ?? undefined;
    message.vanishing_enabled = object.vanishing_enabled ?? undefined;
    message.vanish_at_time = object.vanish_at_time ?? undefined;
    message.recurrence_rule = object.recurrence_rule ?? undefined;
    message.notify_enabled = object.notify_enabled ?? undefined;
    message.notify_before = object.notify_before ?? undefined;
    message.project_id = object.project_id ?? undefined;
    message.visibility = object.visibility ?? undefined;
    message.tags = object.tags?.map((e) => e) || [];
    return message;
  },
};

function createBaseUpdateTodoRequest(): UpdateTodoRequest {
  return { fields: undefined, scope: 0 };
}

export const UpdateTodoRequest: MessageFns<UpdateTodoRequest> = {
  encode(message: UpdateTodoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fields !== undefined) {
      Struct.encode(Struct.wrap(message.fields), writer.uint32(10).fork()).join();
    }
    if (message.scope !== 0) {
      writer.uint32(16).int32(message.scope);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateTodoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateTodoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fields = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.scope = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateTodoRequest {
    return {
      fields: isObject(object.fields) ? object.fields : undefined,
      scope: isSet(object.scope) ? recurringScopeFromJSON(object.scope) : 0,
    };
  },

  toJSON(message: UpdateTodoRequest): unknown {
    const obj: any = {};
    if (message.fields !== undefined) {
      obj.fields = message.fields;
    }
    if (message.scope !== 0) {
      obj.scope = recurringScopeToJSON(message.scope);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateTodoRequest>): UpdateTodoRequest {
    return UpdateTodoRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateTodoRequest>): UpdateTodoRequest {
    const message = createBaseUpdateTodoRequest();
    message.fields = object.fields ?? undefined;
    message.scope = object.scope ?? 0;
    return message;
  },
};

function createBaseSmartTodoRequest(): SmartTodoRequest {
  return { text: "", timezone: "", client_id: "" };
}

export const SmartTodoRequest: MessageFns<SmartTodoRequest> = {
  encode(message: SmartTodoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.text !== "") {
      writer.uint32(10).string(message.text);
    }
    if (message.timezone !== "") {
      writer.uint32(18).string(message.timezone);
    }
    if (message.client_id !== "") {
      writer.uint32(26).string(message.client_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SmartTodoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSmartTodoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.timezone = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.client_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SmartTodoRequest {
    return {
      text: isSet(object.text) ? globalThis.String(object.text) : "",
      timezone: isSet(object.timezone) ? globalThis.String(object.timezone) : "",
      client_id: isSet(object.client_id) ? globalThis.String(object.client_id) : "",
    };
  },

  toJSON(message: SmartTodoRequest): unknown {
    const obj: any = {};
    if (message.text !== "") {
      obj.text = message.text;
    }
    if (message.timezone !== "") {
      obj.timezone = message.timezone;
    }
    if (message.client_id !== "") {
      obj.client_id = message.client_id;
    }
    return obj;
  },

  create(base?: DeepPartial<SmartTodoRequest>): SmartTodoRequest {
    return SmartTodoRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SmartTodoRequest>): SmartTodoRequest {
    const message = createBaseSmartTodoRequest();
    message.text = object.text ?? "";
    message.timezone = object.timezone ?? "";
    message.client_id = object.client_id ?? "";
    return message;
  },
};

function createBaseSmartTodoResponse(): SmartTodoResponse {
  return {
    action: "",
    deleted_todo_id: undefined,
    completed_todo_id: undefined,
    completed_at: undefined,
    updated_todo_id: undefined,
    updated_fields: [],
    todo: undefined,
    todos: [],
  };
}

export const SmartTodoResponse: MessageFns<SmartTodoResponse> = {
  encode(message: SmartTodoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.action !== "") {
      writer.uint32(10).string(message.action);
    }
    if (message.deleted_todo_id !== undefined) {
      writer.uint32(18).string(message.deleted_todo_id);
    }
    if (message.completed_todo_id !== undefined) {
      writer.uint32(26).string(message.completed_todo_id);
    }
    if (message.completed_at !== undefined) {
      Timestamp.encode(toTimestamp(message.completed_at), writer.uint32(34).fork()).join();
    }
    if (message.updated_todo_id !== undefined) {
      writer.uint32(42).string(message.updated_todo_id);
    }
    for (const v of message.updated_fields) {
      writer.uint32(50).string(v!);
    }
    if (message.todo !== undefined) {
      Todo.encode(message.todo, writer.uint32(58).fork()).join();
    }
    for (const v of message.todos) {
      Todo.encode(v!, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SmartTodoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSmartTodoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.action = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.deleted_todo_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.completed_todo_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.completed_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.updated_todo_id = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.updated_fields.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.todo = Todo.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.todos.push(Todo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SmartTodoResponse {
    return {
      action: isSet(object.action) ? globalThis.String(object.action) : "",
      deleted_todo_id: isSet(object.deleted_todo_id) ? globalThis.String(object.deleted_todo_id) : undefined,
      completed_todo_id: isSet(object.completed_todo_id) ? globalThis.String(object.completed_todo_id) : undefined,
      completed_at: isSet(object.completed_at) ? globalThis.String(object.completed_at) : undefined,
      updated_todo_id: isSet(object.updated_todo_id) ? globalThis.String(object.updated_todo_id) : undefined,
      updated_fields: globalThis.Array.isArray(object?.updated_fields)
        ? object.updated_fields.map((e: any) => globalThis.String(e))
        : [],
      todo: isSet(object.todo) ? Todo.fromJSON(object.todo) : undefined,
      todos: globalThis.Array.isArray(object?.todos) ? object.todos.map((e: any) => Todo.fromJSON(e)) : [],
    };
  },

  toJSON(message: SmartTodoResponse): unknown {
    const obj: any = {};
    if (message.action !== "") {
      obj.action = message.action;
    }
    if (message.deleted_todo_id !== undefined) {
      obj.deleted_todo_id = message.deleted_todo_id;
    }
    if (message.completed_todo_id !== undefined) {
      obj.completed_todo_id = message.completed_todo_id;
    }
    if (message.completed_at !== undefined) {
      obj.completed_at = message.completed_at;
    }
    if (message.updated_todo_id !== undefined) {
      obj.updated_todo_id = message.updated_todo_id;
    }
    if (message.updated_fields?.length) {
      obj.updated_fields = message.updated_fields;
    }
    if (message.todo !== undefined) {
      obj.todo = Todo.toJSON(message.todo);
    }
    if (message.todos?.length) {
      obj.todos = message.todos.map((e) => Todo.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<SmartTodoResponse>): SmartTodoResponse {
    return SmartTodoResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SmartTodoResponse>): SmartTodoResponse {
    const message = createBaseSmartTodoResponse();
    message.action = object.action ?? "";
    message.deleted_todo_id = object.deleted_todo_id ?? undefined;
    message.completed_todo_id = object.completed_todo_id ?? undefined;
    message.completed_at = object.completed_at ?? undefined;
    message.updated_todo_id = object.updated_todo_id ?? undefined;
    message.updated_fields = object.updated_fields?.map((e) => e) || [];
    message.todo = (object.todo !== undefined && object.todo !== null) ? Todo.fromPartial(object.todo) : undefined;
    message.todos = object.todos?.map((e) => Todo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSnoozeRequest(): SnoozeRequest {
  return { duration_hours: undefined, until: undefined };
}

export const SnoozeRequest: MessageFns<SnoozeRequest> = {
  encode(message: SnoozeRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.duration_hours !== undefined) {
      writer.uint32(8).int32(message.duration_hours);
    }
    if (message.until !== undefined) {
      Timestamp.encode(toTimestamp(message.until), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SnoozeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSnoozeRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.duration_hours = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.until = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SnoozeRequest {
    return {
      duration_hours: isSet(object.duration_hours) ? globalThis.Number(object.duration_hours) : undefined,
      until: isSet(object.until) ? globalThis.String(object.until) : undefined,
    };
  },

  toJSON(message: SnoozeRequest): unknown {
    const obj: any = {};
    if (message.duration_hours !== undefined) {
      obj.duration_hours = Math.round(message.duration_hours);
    }
    if (message.until !== undefined) {
      obj.until = message.until;
    }
    return obj;
  },

  create(base?: DeepPartial<SnoozeRequest>): SnoozeRequest {
    return SnoozeRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SnoozeRequest>): SnoozeRequest {
    const message = createBaseSnoozeRequest();
    message.duration_hours = object.duration_hours ?? undefined;
    message.until = object.until ?? undefined;
    return message;
  },
};

function createBaseCompleteRequest(): CompleteRequest {
  return { completed_at: undefined };
}

export const CompleteRequest: MessageFns<CompleteRequest> = {
  encode(message: CompleteRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.completed_at !== undefined) {
      Timestamp.encode(toTimestamp(message.completed_at), writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompleteRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompleteRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.completed_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompleteRequest {
    return { completed_at: isSet(object.completed_at) ? globalThis.String(object.completed_at) : undefined };
  },

  toJSON(message: CompleteRequest): unknown {
    const obj: any = {};
    if (message.completed_at !== undefined) {
      obj.completed_at = message.completed_at;
    }
    return obj;
  },

  create(base?: DeepPartial<CompleteRequest>): CompleteRequest {
    return CompleteRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CompleteRequest>): CompleteRequest {
    const message = createBaseCompleteRequest();
    message.completed_at = object.completed_at ?? undefined;
    return message;
  },
};

function createBaseScheduleCompleteResponse(): ScheduleCompleteResponse {
  return { workflow_id: "" };
}

export const ScheduleCompleteResponse: MessageFns<ScheduleCompleteResponse> = {
  encode(message: ScheduleCompleteResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.workflow_id !== "") {
      writer.uint32(10).string(message.workflow_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScheduleCompleteResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScheduleCompleteResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.workflow_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScheduleCompleteResponse {
    return { workflow_id: isSet(object.workflow_id) ? globalThis.String(object.workflow_id) : "" };
  },

  toJSON(message: ScheduleCompleteResponse): unknown {
    const obj: any = {};
    if (message.workflow_id !== "") {
      obj.workflow_id = message.workflow_id;
    }
    return obj;
  },

  create(base?: DeepPartial<ScheduleCompleteResponse>): ScheduleCompleteResponse {
    return ScheduleCompleteResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ScheduleCompleteResponse>): ScheduleCompleteResponse {
    const message = createBaseScheduleCompleteResponse();
    message.workflow_id = object.workflow_id ?? "";
    return message;
  },
};

function createBaseUpdateCompletionRequest(): UpdateCompletionRequest {
  return { close_reason: "" };
}

export const UpdateCompletionRequest: MessageFns<UpdateCompletionRequest> = {
  encode(message: UpdateCompletionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.close_reason !== "") {
      writer.uint32(10).string(message.close_reason);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateCompletionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateCompletionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.close_reason = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateCompletionRequest {
    return { close_reason: isSet(object.close_reason) ? globalThis.String(object.close_reason) : "" };
  },

  toJSON(message: UpdateCompletionRequest): unknown {
    const obj: any = {};
    if (message.close_reason !== "") {
      obj.close_reason = message.close_reason;
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateCompletionRequest>): UpdateCompletionRequest {
    return UpdateCompletionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateCompletionRequest>): UpdateCompletionRequest {
    const message = createBaseUpdateCompletionRequest();
    message.close_reason = object.close_reason ?? "";
    return message;
  },
};

function createBaseTodoListResponse(): TodoListResponse {
  return { items: [], pagination: undefined };
}

export const TodoListResponse: MessageFns<TodoListResponse> = {
  encode(message: TodoListResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      Todo.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.pagination !== undefined) {
      PaginationMeta.encode(message.pagination, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TodoListResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTodoListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.items.push(Todo.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pagination = PaginationMeta.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TodoListResponse {
    return {
      items: globalThis.Array.isArray(object?.items) ? object.items.map((e: any) => Todo.fromJSON(e)) : [],
      pagination: isSet(object.pagination) ? PaginationMeta.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: TodoListResponse): unknown {
    const obj: any = {};
    if (message.items?.length) {
      obj.items = message.items.map((e) => Todo.toJSON(e));
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationMeta.toJSON(message.pagination);
    }
    return obj;
  },

  create(base?: DeepPartial<TodoListResponse>): TodoListResponse {
    return TodoListResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TodoListResponse>): TodoListResponse {
    const message = createBaseTodoListResponse();
    message.items = object.items?.map((e) => Todo.fromPartial(e)) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationMeta.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseTodoCompletionListResponse(): TodoCompletionListResponse {
  return { items: [], pagination: undefined };
}

export const TodoCompletionListResponse: MessageFns<TodoCompletionListResponse> = {
  encode(message: TodoCompletionListResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      TodoCompletion.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.pagination !== undefined) {
      PaginationMeta.encode(message.pagination, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TodoCompletionListResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTodoCompletionListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.items.push(TodoCompletion.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pagination = PaginationMeta.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TodoCompletionListResponse {
    return {
      items: globalThis.Array.isArray(object?.items) ? object.items.map((e: any) => TodoCompletion.fromJSON(e)) : [],
      pagination: isSet(object.pagination) ? PaginationMeta.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: TodoCompletionListResponse): unknown {
    const obj: any = {};
    if (message.items?.length) {
      obj.items = message.items.map((e) => TodoCompletion.toJSON(e));
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationMeta.toJSON(message.pagination);
    }
    return obj;
  },

  create(base?: DeepPartial<TodoCompletionListResponse>): TodoCompletionListResponse {
    return TodoCompletionListResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TodoCompletionListResponse>): TodoCompletionListResponse {
    const message = createBaseTodoCompletionListResponse();
    message.items = object.items?.map((e) => TodoCompletion.fromPartial(e)) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationMeta.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseTagListResponse(): TagListResponse {
  return { tags: [] };
}

export const TagListResponse: MessageFns<TagListResponse> = {
  encode(message: TagListResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tags) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TagListResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTagListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tags.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TagListResponse {
    return { tags: globalThis.Array.isArray(object?.tags) ? object.tags.map((e: any) => globalThis.String(e)) : [] };
  },

  toJSON(message: TagListResponse): unknown {
    const obj: any = {};
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    return obj;
  },

  create(base?: DeepPartial<TagListResponse>): TagListResponse {
    return TagListResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TagListResponse>): TagListResponse {
    const message = createBaseTagListResponse();
    message.tags = object.tags?.map((e) => e) || [];
    return message;
  },
};

function createBaseBriefItem(): BriefItem {
  return {
    id: "",
    title: "",
    status: "",
    owner: undefined,
    type_tag: undefined,
    context_blob: undefined,
    due_at: undefined,
    source_plugin: "",
  };
}

export const BriefItem: MessageFns<BriefItem> = {
  encode(message: BriefItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.status !== "") {
      writer.uint32(26).string(message.status);
    }
    if (message.owner !== undefined) {
      User.encode(message.owner, writer.uint32(34).fork()).join();
    }
    if (message.type_tag !== undefined) {
      writer.uint32(42).string(message.type_tag);
    }
    if (message.context_blob !== undefined) {
      Struct.encode(Struct.wrap(message.context_blob), writer.uint32(50).fork()).join();
    }
    if (message.due_at !== undefined) {
      Timestamp.encode(toTimestamp(message.due_at), writer.uint32(58).fork()).join();
    }
    if (message.source_plugin !== "") {
      writer.uint32(66).string(message.source_plugin);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BriefItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBriefItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.owner = User.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.type_tag = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.context_blob = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.due_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.source_plugin = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BriefItem {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      owner: isSet(object.owner) ? User.fromJSON(object.owner) : undefined,
      type_tag: isSet(object.type_tag) ? globalThis.String(object.type_tag) : undefined,
      context_blob: isObject(object.context_blob) ? object.context_blob : undefined,
      due_at: isSet(object.due_at) ? globalThis.String(object.due_at) : undefined,
      source_plugin: isSet(object.source_plugin) ? globalThis.String(object.source_plugin) : "",
    };
  },

  toJSON(message: BriefItem): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.owner !== undefined) {
      obj.owner = User.toJSON(message.owner);
    }
    if (message.type_tag !== undefined) {
      obj.type_tag = message.type_tag;
    }
    if (message.context_blob !== undefined) {
      obj.context_blob = message.context_blob;
    }
    if (message.due_at !== undefined) {
      obj.due_at = message.due_at;
    }
    if (message.source_plugin !== "") {
      obj.source_plugin = message.source_plugin;
    }
    return obj;
  },

  create(base?: DeepPartial<BriefItem>): BriefItem {
    return BriefItem.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BriefItem>): BriefItem {
    const message = createBaseBriefItem();
    message.id = object.id ?? "";
    message.title = object.title ?? "";
    message.status = object.status ?? "";
    message.owner = (object.owner !== undefined && object.owner !== null) ? User.fromPartial(object.owner) : undefined;
    message.type_tag = object.type_tag ?? undefined;
    message.context_blob = object.context_blob ?? undefined;
    message.due_at = object.due_at ?? undefined;
    message.source_plugin = object.source_plugin ?? "";
    return message;
  },
};

function createBaseBriefSection(): BriefSection {
  return { name: "", items: [] };
}

export const BriefSection: MessageFns<BriefSection> = {
  encode(message: BriefSection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    for (const v of message.items) {
      BriefItem.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BriefSection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBriefSection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.items.push(BriefItem.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BriefSection {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      items: globalThis.Array.isArray(object?.items) ? object.items.map((e: any) => BriefItem.fromJSON(e)) : [],
    };
  },

  toJSON(message: BriefSection): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.items?.length) {
      obj.items = message.items.map((e) => BriefItem.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<BriefSection>): BriefSection {
    return BriefSection.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BriefSection>): BriefSection {
    const message = createBaseBriefSection();
    message.name = object.name ?? "";
    message.items = object.items?.map((e) => BriefItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBriefResponse(): BriefResponse {
  return { date: "", sections: [] };
}

export const BriefResponse: MessageFns<BriefResponse> = {
  encode(message: BriefResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.date !== "") {
      writer.uint32(10).string(message.date);
    }
    for (const v of message.sections) {
      BriefSection.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BriefResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBriefResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.date = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.sections.push(BriefSection.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BriefResponse {
    return {
      date: isSet(object.date) ? globalThis.String(object.date) : "",
      sections: globalThis.Array.isArray(object?.sections)
        ? object.sections.map((e: any) => BriefSection.fromJSON(e))
        : [],
    };
  },

  toJSON(message: BriefResponse): unknown {
    const obj: any = {};
    if (message.date !== "") {
      obj.date = message.date;
    }
    if (message.sections?.length) {
      obj.sections = message.sections.map((e) => BriefSection.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<BriefResponse>): BriefResponse {
    return BriefResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BriefResponse>): BriefResponse {
    const message = createBaseBriefResponse();
    message.date = object.date ?? "";
    message.sections = object.sections?.map((e) => BriefSection.fromPartial(e)) || [];
    return message;
  },
};

function createBaseListCompletionsRequest(): ListCompletionsRequest {
  return { pagination: undefined, limit: 0, offset: 0, page: 0, q: "" };
}

export const ListCompletionsRequest: MessageFns<ListCompletionsRequest> = {
  encode(message: ListCompletionsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pagination !== undefined) {
      PaginationRequest.encode(message.pagination, writer.uint32(10).fork()).join();
    }
    if (message.limit !== 0) {
      writer.uint32(16).int32(message.limit);
    }
    if (message.offset !== 0) {
      writer.uint32(24).int32(message.offset);
    }
    if (message.page !== 0) {
      writer.uint32(32).int32(message.page);
    }
    if (message.q !== "") {
      writer.uint32(42).string(message.q);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListCompletionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListCompletionsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pagination = PaginationRequest.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.limit = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.offset = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.page = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.q = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListCompletionsRequest {
    return {
      pagination: isSet(object.pagination) ? PaginationRequest.fromJSON(object.pagination) : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : 0,
      offset: isSet(object.offset) ? globalThis.Number(object.offset) : 0,
      page: isSet(object.page) ? globalThis.Number(object.page) : 0,
      q: isSet(object.q) ? globalThis.String(object.q) : "",
    };
  },

  toJSON(message: ListCompletionsRequest): unknown {
    const obj: any = {};
    if (message.pagination !== undefined) {
      obj.pagination = PaginationRequest.toJSON(message.pagination);
    }
    if (message.limit !== 0) {
      obj.limit = Math.round(message.limit);
    }
    if (message.offset !== 0) {
      obj.offset = Math.round(message.offset);
    }
    if (message.page !== 0) {
      obj.page = Math.round(message.page);
    }
    if (message.q !== "") {
      obj.q = message.q;
    }
    return obj;
  },

  create(base?: DeepPartial<ListCompletionsRequest>): ListCompletionsRequest {
    return ListCompletionsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListCompletionsRequest>): ListCompletionsRequest {
    const message = createBaseListCompletionsRequest();
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationRequest.fromPartial(object.pagination)
      : undefined;
    message.limit = object.limit ?? 0;
    message.offset = object.offset ?? 0;
    message.page = object.page ?? 0;
    message.q = object.q ?? "";
    return message;
  },
};

function createBaseUpdateCompletionPathRequest(): UpdateCompletionPathRequest {
  return { id: "", close_reason: "" };
}

export const UpdateCompletionPathRequest: MessageFns<UpdateCompletionPathRequest> = {
  encode(message: UpdateCompletionPathRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.close_reason !== "") {
      writer.uint32(18).string(message.close_reason);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateCompletionPathRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateCompletionPathRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.close_reason = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateCompletionPathRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      close_reason: isSet(object.close_reason) ? globalThis.String(object.close_reason) : "",
    };
  },

  toJSON(message: UpdateCompletionPathRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.close_reason !== "") {
      obj.close_reason = message.close_reason;
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateCompletionPathRequest>): UpdateCompletionPathRequest {
    return UpdateCompletionPathRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateCompletionPathRequest>): UpdateCompletionPathRequest {
    const message = createBaseUpdateCompletionPathRequest();
    message.id = object.id ?? "";
    message.close_reason = object.close_reason ?? "";
    return message;
  },
};

function createBaseGetTodoRequest(): GetTodoRequest {
  return { id: "" };
}

export const GetTodoRequest: MessageFns<GetTodoRequest> = {
  encode(message: GetTodoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTodoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTodoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTodoRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: GetTodoRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<GetTodoRequest>): GetTodoRequest {
    return GetTodoRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetTodoRequest>): GetTodoRequest {
    const message = createBaseGetTodoRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseListTodosRequest(): ListTodosRequest {
  return { status: undefined, project_id: undefined, pagination: undefined };
}

export const ListTodosRequest: MessageFns<ListTodosRequest> = {
  encode(message: ListTodosRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== undefined) {
      writer.uint32(10).string(message.status);
    }
    if (message.project_id !== undefined) {
      writer.uint32(18).string(message.project_id);
    }
    if (message.pagination !== undefined) {
      PaginationRequest.encode(message.pagination, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListTodosRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListTodosRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.project_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.pagination = PaginationRequest.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListTodosRequest {
    return {
      status: isSet(object.status) ? globalThis.String(object.status) : undefined,
      project_id: isSet(object.project_id) ? globalThis.String(object.project_id) : undefined,
      pagination: isSet(object.pagination) ? PaginationRequest.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: ListTodosRequest): unknown {
    const obj: any = {};
    if (message.status !== undefined) {
      obj.status = message.status;
    }
    if (message.project_id !== undefined) {
      obj.project_id = message.project_id;
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationRequest.toJSON(message.pagination);
    }
    return obj;
  },

  create(base?: DeepPartial<ListTodosRequest>): ListTodosRequest {
    return ListTodosRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListTodosRequest>): ListTodosRequest {
    const message = createBaseListTodosRequest();
    message.status = object.status ?? undefined;
    message.project_id = object.project_id ?? undefined;
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationRequest.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseUpdateTodoPathRequest(): UpdateTodoPathRequest {
  return { id: "", fields: undefined, scope: 0, client_clone_id: undefined };
}

export const UpdateTodoPathRequest: MessageFns<UpdateTodoPathRequest> = {
  encode(message: UpdateTodoPathRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.fields !== undefined) {
      Struct.encode(Struct.wrap(message.fields), writer.uint32(18).fork()).join();
    }
    if (message.scope !== 0) {
      writer.uint32(24).int32(message.scope);
    }
    if (message.client_clone_id !== undefined) {
      writer.uint32(34).string(message.client_clone_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateTodoPathRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateTodoPathRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fields = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.scope = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.client_clone_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateTodoPathRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      fields: isObject(object.fields) ? object.fields : undefined,
      scope: isSet(object.scope) ? recurringScopeFromJSON(object.scope) : 0,
      client_clone_id: isSet(object.client_clone_id) ? globalThis.String(object.client_clone_id) : undefined,
    };
  },

  toJSON(message: UpdateTodoPathRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.fields !== undefined) {
      obj.fields = message.fields;
    }
    if (message.scope !== 0) {
      obj.scope = recurringScopeToJSON(message.scope);
    }
    if (message.client_clone_id !== undefined) {
      obj.client_clone_id = message.client_clone_id;
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateTodoPathRequest>): UpdateTodoPathRequest {
    return UpdateTodoPathRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateTodoPathRequest>): UpdateTodoPathRequest {
    const message = createBaseUpdateTodoPathRequest();
    message.id = object.id ?? "";
    message.fields = object.fields ?? undefined;
    message.scope = object.scope ?? 0;
    message.client_clone_id = object.client_clone_id ?? undefined;
    return message;
  },
};

function createBaseUpdateTodoResponse(): UpdateTodoResponse {
  return { todo: undefined, advanced_series: undefined };
}

export const UpdateTodoResponse: MessageFns<UpdateTodoResponse> = {
  encode(message: UpdateTodoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.todo !== undefined) {
      Todo.encode(message.todo, writer.uint32(10).fork()).join();
    }
    if (message.advanced_series !== undefined) {
      Todo.encode(message.advanced_series, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateTodoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateTodoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.todo = Todo.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.advanced_series = Todo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateTodoResponse {
    return {
      todo: isSet(object.todo) ? Todo.fromJSON(object.todo) : undefined,
      advanced_series: isSet(object.advanced_series) ? Todo.fromJSON(object.advanced_series) : undefined,
    };
  },

  toJSON(message: UpdateTodoResponse): unknown {
    const obj: any = {};
    if (message.todo !== undefined) {
      obj.todo = Todo.toJSON(message.todo);
    }
    if (message.advanced_series !== undefined) {
      obj.advanced_series = Todo.toJSON(message.advanced_series);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateTodoResponse>): UpdateTodoResponse {
    return UpdateTodoResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateTodoResponse>): UpdateTodoResponse {
    const message = createBaseUpdateTodoResponse();
    message.todo = (object.todo !== undefined && object.todo !== null) ? Todo.fromPartial(object.todo) : undefined;
    message.advanced_series = (object.advanced_series !== undefined && object.advanced_series !== null)
      ? Todo.fromPartial(object.advanced_series)
      : undefined;
    return message;
  },
};

function createBaseDeleteTodoRequest(): DeleteTodoRequest {
  return { id: "" };
}

export const DeleteTodoRequest: MessageFns<DeleteTodoRequest> = {
  encode(message: DeleteTodoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteTodoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteTodoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteTodoRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: DeleteTodoRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<DeleteTodoRequest>): DeleteTodoRequest {
    return DeleteTodoRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteTodoRequest>): DeleteTodoRequest {
    const message = createBaseDeleteTodoRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseCompleteTodoRequest(): CompleteTodoRequest {
  return { id: "", completed_at: undefined, client_completion_id: undefined };
}

export const CompleteTodoRequest: MessageFns<CompleteTodoRequest> = {
  encode(message: CompleteTodoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.completed_at !== undefined) {
      Timestamp.encode(toTimestamp(message.completed_at), writer.uint32(18).fork()).join();
    }
    if (message.client_completion_id !== undefined) {
      writer.uint32(26).string(message.client_completion_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompleteTodoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompleteTodoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.completed_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.client_completion_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompleteTodoRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      completed_at: isSet(object.completed_at) ? globalThis.String(object.completed_at) : undefined,
      client_completion_id: isSet(object.client_completion_id)
        ? globalThis.String(object.client_completion_id)
        : undefined,
    };
  },

  toJSON(message: CompleteTodoRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.completed_at !== undefined) {
      obj.completed_at = message.completed_at;
    }
    if (message.client_completion_id !== undefined) {
      obj.client_completion_id = message.client_completion_id;
    }
    return obj;
  },

  create(base?: DeepPartial<CompleteTodoRequest>): CompleteTodoRequest {
    return CompleteTodoRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CompleteTodoRequest>): CompleteTodoRequest {
    const message = createBaseCompleteTodoRequest();
    message.id = object.id ?? "";
    message.completed_at = object.completed_at ?? undefined;
    message.client_completion_id = object.client_completion_id ?? undefined;
    return message;
  },
};

function createBaseRecurringSeriesSummary(): RecurringSeriesSummary {
  return { series_id: "", title: "", recurrence_rule: "", current_due_at: undefined };
}

export const RecurringSeriesSummary: MessageFns<RecurringSeriesSummary> = {
  encode(message: RecurringSeriesSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.series_id !== "") {
      writer.uint32(10).string(message.series_id);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.recurrence_rule !== "") {
      writer.uint32(26).string(message.recurrence_rule);
    }
    if (message.current_due_at !== undefined) {
      Timestamp.encode(toTimestamp(message.current_due_at), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RecurringSeriesSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRecurringSeriesSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.series_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.recurrence_rule = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.current_due_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RecurringSeriesSummary {
    return {
      series_id: isSet(object.series_id) ? globalThis.String(object.series_id) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      recurrence_rule: isSet(object.recurrence_rule) ? globalThis.String(object.recurrence_rule) : "",
      current_due_at: isSet(object.current_due_at) ? globalThis.String(object.current_due_at) : undefined,
    };
  },

  toJSON(message: RecurringSeriesSummary): unknown {
    const obj: any = {};
    if (message.series_id !== "") {
      obj.series_id = message.series_id;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.recurrence_rule !== "") {
      obj.recurrence_rule = message.recurrence_rule;
    }
    if (message.current_due_at !== undefined) {
      obj.current_due_at = message.current_due_at;
    }
    return obj;
  },

  create(base?: DeepPartial<RecurringSeriesSummary>): RecurringSeriesSummary {
    return RecurringSeriesSummary.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RecurringSeriesSummary>): RecurringSeriesSummary {
    const message = createBaseRecurringSeriesSummary();
    message.series_id = object.series_id ?? "";
    message.title = object.title ?? "";
    message.recurrence_rule = object.recurrence_rule ?? "";
    message.current_due_at = object.current_due_at ?? undefined;
    return message;
  },
};

function createBaseRecurringSeriesListResponse(): RecurringSeriesListResponse {
  return { series: [] };
}

export const RecurringSeriesListResponse: MessageFns<RecurringSeriesListResponse> = {
  encode(message: RecurringSeriesListResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.series) {
      RecurringSeriesSummary.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RecurringSeriesListResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRecurringSeriesListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.series.push(RecurringSeriesSummary.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RecurringSeriesListResponse {
    return {
      series: globalThis.Array.isArray(object?.series)
        ? object.series.map((e: any) => RecurringSeriesSummary.fromJSON(e))
        : [],
    };
  },

  toJSON(message: RecurringSeriesListResponse): unknown {
    const obj: any = {};
    if (message.series?.length) {
      obj.series = message.series.map((e) => RecurringSeriesSummary.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<RecurringSeriesListResponse>): RecurringSeriesListResponse {
    return RecurringSeriesListResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RecurringSeriesListResponse>): RecurringSeriesListResponse {
    const message = createBaseRecurringSeriesListResponse();
    message.series = object.series?.map((e) => RecurringSeriesSummary.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCompleteCurrentInSeriesRequest(): CompleteCurrentInSeriesRequest {
  return { series_id: "", client_completion_id: undefined };
}

export const CompleteCurrentInSeriesRequest: MessageFns<CompleteCurrentInSeriesRequest> = {
  encode(message: CompleteCurrentInSeriesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.series_id !== "") {
      writer.uint32(10).string(message.series_id);
    }
    if (message.client_completion_id !== undefined) {
      writer.uint32(18).string(message.client_completion_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompleteCurrentInSeriesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompleteCurrentInSeriesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.series_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.client_completion_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompleteCurrentInSeriesRequest {
    return {
      series_id: isSet(object.series_id) ? globalThis.String(object.series_id) : "",
      client_completion_id: isSet(object.client_completion_id)
        ? globalThis.String(object.client_completion_id)
        : undefined,
    };
  },

  toJSON(message: CompleteCurrentInSeriesRequest): unknown {
    const obj: any = {};
    if (message.series_id !== "") {
      obj.series_id = message.series_id;
    }
    if (message.client_completion_id !== undefined) {
      obj.client_completion_id = message.client_completion_id;
    }
    return obj;
  },

  create(base?: DeepPartial<CompleteCurrentInSeriesRequest>): CompleteCurrentInSeriesRequest {
    return CompleteCurrentInSeriesRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CompleteCurrentInSeriesRequest>): CompleteCurrentInSeriesRequest {
    const message = createBaseCompleteCurrentInSeriesRequest();
    message.series_id = object.series_id ?? "";
    message.client_completion_id = object.client_completion_id ?? undefined;
    return message;
  },
};

function createBaseCompleteCurrentInSeriesResponse(): CompleteCurrentInSeriesResponse {
  return { completed: false, completed_todo: undefined, next_todo: undefined };
}

export const CompleteCurrentInSeriesResponse: MessageFns<CompleteCurrentInSeriesResponse> = {
  encode(message: CompleteCurrentInSeriesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.completed !== false) {
      writer.uint32(8).bool(message.completed);
    }
    if (message.completed_todo !== undefined) {
      Todo.encode(message.completed_todo, writer.uint32(18).fork()).join();
    }
    if (message.next_todo !== undefined) {
      Todo.encode(message.next_todo, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompleteCurrentInSeriesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompleteCurrentInSeriesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.completed = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.completed_todo = Todo.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.next_todo = Todo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompleteCurrentInSeriesResponse {
    return {
      completed: isSet(object.completed) ? globalThis.Boolean(object.completed) : false,
      completed_todo: isSet(object.completed_todo) ? Todo.fromJSON(object.completed_todo) : undefined,
      next_todo: isSet(object.next_todo) ? Todo.fromJSON(object.next_todo) : undefined,
    };
  },

  toJSON(message: CompleteCurrentInSeriesResponse): unknown {
    const obj: any = {};
    if (message.completed !== false) {
      obj.completed = message.completed;
    }
    if (message.completed_todo !== undefined) {
      obj.completed_todo = Todo.toJSON(message.completed_todo);
    }
    if (message.next_todo !== undefined) {
      obj.next_todo = Todo.toJSON(message.next_todo);
    }
    return obj;
  },

  create(base?: DeepPartial<CompleteCurrentInSeriesResponse>): CompleteCurrentInSeriesResponse {
    return CompleteCurrentInSeriesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CompleteCurrentInSeriesResponse>): CompleteCurrentInSeriesResponse {
    const message = createBaseCompleteCurrentInSeriesResponse();
    message.completed = object.completed ?? false;
    message.completed_todo = (object.completed_todo !== undefined && object.completed_todo !== null)
      ? Todo.fromPartial(object.completed_todo)
      : undefined;
    message.next_todo = (object.next_todo !== undefined && object.next_todo !== null)
      ? Todo.fromPartial(object.next_todo)
      : undefined;
    return message;
  },
};

function createBaseScheduleCompleteTodoRequest(): ScheduleCompleteTodoRequest {
  return { id: "", completed_at: undefined, client_completion_id: undefined };
}

export const ScheduleCompleteTodoRequest: MessageFns<ScheduleCompleteTodoRequest> = {
  encode(message: ScheduleCompleteTodoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.completed_at !== undefined) {
      Timestamp.encode(toTimestamp(message.completed_at), writer.uint32(18).fork()).join();
    }
    if (message.client_completion_id !== undefined) {
      writer.uint32(26).string(message.client_completion_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScheduleCompleteTodoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScheduleCompleteTodoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.completed_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.client_completion_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScheduleCompleteTodoRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      completed_at: isSet(object.completed_at) ? globalThis.String(object.completed_at) : undefined,
      client_completion_id: isSet(object.client_completion_id)
        ? globalThis.String(object.client_completion_id)
        : undefined,
    };
  },

  toJSON(message: ScheduleCompleteTodoRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.completed_at !== undefined) {
      obj.completed_at = message.completed_at;
    }
    if (message.client_completion_id !== undefined) {
      obj.client_completion_id = message.client_completion_id;
    }
    return obj;
  },

  create(base?: DeepPartial<ScheduleCompleteTodoRequest>): ScheduleCompleteTodoRequest {
    return ScheduleCompleteTodoRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ScheduleCompleteTodoRequest>): ScheduleCompleteTodoRequest {
    const message = createBaseScheduleCompleteTodoRequest();
    message.id = object.id ?? "";
    message.completed_at = object.completed_at ?? undefined;
    message.client_completion_id = object.client_completion_id ?? undefined;
    return message;
  },
};

function createBaseCancelScheduledCompleteTodoRequest(): CancelScheduledCompleteTodoRequest {
  return { id: "" };
}

export const CancelScheduledCompleteTodoRequest: MessageFns<CancelScheduledCompleteTodoRequest> = {
  encode(message: CancelScheduledCompleteTodoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CancelScheduledCompleteTodoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCancelScheduledCompleteTodoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CancelScheduledCompleteTodoRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: CancelScheduledCompleteTodoRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<CancelScheduledCompleteTodoRequest>): CancelScheduledCompleteTodoRequest {
    return CancelScheduledCompleteTodoRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CancelScheduledCompleteTodoRequest>): CancelScheduledCompleteTodoRequest {
    const message = createBaseCancelScheduledCompleteTodoRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseSnoozeTodoRequest(): SnoozeTodoRequest {
  return { id: "", duration_hours: undefined, until: undefined };
}

export const SnoozeTodoRequest: MessageFns<SnoozeTodoRequest> = {
  encode(message: SnoozeTodoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.duration_hours !== undefined) {
      writer.uint32(16).int32(message.duration_hours);
    }
    if (message.until !== undefined) {
      Timestamp.encode(toTimestamp(message.until), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SnoozeTodoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSnoozeTodoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.duration_hours = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.until = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SnoozeTodoRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      duration_hours: isSet(object.duration_hours) ? globalThis.Number(object.duration_hours) : undefined,
      until: isSet(object.until) ? globalThis.String(object.until) : undefined,
    };
  },

  toJSON(message: SnoozeTodoRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.duration_hours !== undefined) {
      obj.duration_hours = Math.round(message.duration_hours);
    }
    if (message.until !== undefined) {
      obj.until = message.until;
    }
    return obj;
  },

  create(base?: DeepPartial<SnoozeTodoRequest>): SnoozeTodoRequest {
    return SnoozeTodoRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SnoozeTodoRequest>): SnoozeTodoRequest {
    const message = createBaseSnoozeTodoRequest();
    message.id = object.id ?? "";
    message.duration_hours = object.duration_hours ?? undefined;
    message.until = object.until ?? undefined;
    return message;
  },
};

function createBaseSkipTodoRequest(): SkipTodoRequest {
  return { id: "" };
}

export const SkipTodoRequest: MessageFns<SkipTodoRequest> = {
  encode(message: SkipTodoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SkipTodoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSkipTodoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SkipTodoRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: SkipTodoRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<SkipTodoRequest>): SkipTodoRequest {
    return SkipTodoRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SkipTodoRequest>): SkipTodoRequest {
    const message = createBaseSkipTodoRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseClaimTodoRequest(): ClaimTodoRequest {
  return { id: "", new_owner_id: "", scope: 0 };
}

export const ClaimTodoRequest: MessageFns<ClaimTodoRequest> = {
  encode(message: ClaimTodoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.new_owner_id !== "") {
      writer.uint32(18).string(message.new_owner_id);
    }
    if (message.scope !== 0) {
      writer.uint32(24).int32(message.scope);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClaimTodoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClaimTodoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.new_owner_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.scope = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClaimTodoRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      new_owner_id: isSet(object.new_owner_id) ? globalThis.String(object.new_owner_id) : "",
      scope: isSet(object.scope) ? recurringScopeFromJSON(object.scope) : 0,
    };
  },

  toJSON(message: ClaimTodoRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.new_owner_id !== "") {
      obj.new_owner_id = message.new_owner_id;
    }
    if (message.scope !== 0) {
      obj.scope = recurringScopeToJSON(message.scope);
    }
    return obj;
  },

  create(base?: DeepPartial<ClaimTodoRequest>): ClaimTodoRequest {
    return ClaimTodoRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ClaimTodoRequest>): ClaimTodoRequest {
    const message = createBaseClaimTodoRequest();
    message.id = object.id ?? "";
    message.new_owner_id = object.new_owner_id ?? "";
    message.scope = object.scope ?? 0;
    return message;
  },
};

function createBaseMoveTodoRequest(): MoveTodoRequest {
  return { id: "", bucket: 0, timezone: "" };
}

export const MoveTodoRequest: MessageFns<MoveTodoRequest> = {
  encode(message: MoveTodoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.bucket !== 0) {
      writer.uint32(16).int32(message.bucket);
    }
    if (message.timezone !== "") {
      writer.uint32(26).string(message.timezone);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MoveTodoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMoveTodoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.bucket = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.timezone = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MoveTodoRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      bucket: isSet(object.bucket) ? todoBucketFromJSON(object.bucket) : 0,
      timezone: isSet(object.timezone) ? globalThis.String(object.timezone) : "",
    };
  },

  toJSON(message: MoveTodoRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.bucket !== 0) {
      obj.bucket = todoBucketToJSON(message.bucket);
    }
    if (message.timezone !== "") {
      obj.timezone = message.timezone;
    }
    return obj;
  },

  create(base?: DeepPartial<MoveTodoRequest>): MoveTodoRequest {
    return MoveTodoRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MoveTodoRequest>): MoveTodoRequest {
    const message = createBaseMoveTodoRequest();
    message.id = object.id ?? "";
    message.bucket = object.bucket ?? 0;
    message.timezone = object.timezone ?? "";
    return message;
  },
};

function createBaseMarkBlockedTodoRequest(): MarkBlockedTodoRequest {
  return { id: "", client_followup_id: undefined, client_completion_id: undefined };
}

export const MarkBlockedTodoRequest: MessageFns<MarkBlockedTodoRequest> = {
  encode(message: MarkBlockedTodoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.client_followup_id !== undefined) {
      writer.uint32(18).string(message.client_followup_id);
    }
    if (message.client_completion_id !== undefined) {
      writer.uint32(26).string(message.client_completion_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MarkBlockedTodoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMarkBlockedTodoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.client_followup_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.client_completion_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MarkBlockedTodoRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      client_followup_id: isSet(object.client_followup_id) ? globalThis.String(object.client_followup_id) : undefined,
      client_completion_id: isSet(object.client_completion_id)
        ? globalThis.String(object.client_completion_id)
        : undefined,
    };
  },

  toJSON(message: MarkBlockedTodoRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.client_followup_id !== undefined) {
      obj.client_followup_id = message.client_followup_id;
    }
    if (message.client_completion_id !== undefined) {
      obj.client_completion_id = message.client_completion_id;
    }
    return obj;
  },

  create(base?: DeepPartial<MarkBlockedTodoRequest>): MarkBlockedTodoRequest {
    return MarkBlockedTodoRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MarkBlockedTodoRequest>): MarkBlockedTodoRequest {
    const message = createBaseMarkBlockedTodoRequest();
    message.id = object.id ?? "";
    message.client_followup_id = object.client_followup_id ?? undefined;
    message.client_completion_id = object.client_completion_id ?? undefined;
    return message;
  },
};

function createBaseMarkBlockedTodoResponse(): MarkBlockedTodoResponse {
  return { followup: undefined, workflow_id: "", working_days: 0, original: undefined, completion: undefined };
}

export const MarkBlockedTodoResponse: MessageFns<MarkBlockedTodoResponse> = {
  encode(message: MarkBlockedTodoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.followup !== undefined) {
      Todo.encode(message.followup, writer.uint32(10).fork()).join();
    }
    if (message.workflow_id !== "") {
      writer.uint32(18).string(message.workflow_id);
    }
    if (message.working_days !== 0) {
      writer.uint32(24).int32(message.working_days);
    }
    if (message.original !== undefined) {
      Todo.encode(message.original, writer.uint32(34).fork()).join();
    }
    if (message.completion !== undefined) {
      TodoCompletion.encode(message.completion, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MarkBlockedTodoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMarkBlockedTodoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.followup = Todo.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.workflow_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.working_days = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.original = Todo.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.completion = TodoCompletion.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MarkBlockedTodoResponse {
    return {
      followup: isSet(object.followup) ? Todo.fromJSON(object.followup) : undefined,
      workflow_id: isSet(object.workflow_id) ? globalThis.String(object.workflow_id) : "",
      working_days: isSet(object.working_days) ? globalThis.Number(object.working_days) : 0,
      original: isSet(object.original) ? Todo.fromJSON(object.original) : undefined,
      completion: isSet(object.completion) ? TodoCompletion.fromJSON(object.completion) : undefined,
    };
  },

  toJSON(message: MarkBlockedTodoResponse): unknown {
    const obj: any = {};
    if (message.followup !== undefined) {
      obj.followup = Todo.toJSON(message.followup);
    }
    if (message.workflow_id !== "") {
      obj.workflow_id = message.workflow_id;
    }
    if (message.working_days !== 0) {
      obj.working_days = Math.round(message.working_days);
    }
    if (message.original !== undefined) {
      obj.original = Todo.toJSON(message.original);
    }
    if (message.completion !== undefined) {
      obj.completion = TodoCompletion.toJSON(message.completion);
    }
    return obj;
  },

  create(base?: DeepPartial<MarkBlockedTodoResponse>): MarkBlockedTodoResponse {
    return MarkBlockedTodoResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MarkBlockedTodoResponse>): MarkBlockedTodoResponse {
    const message = createBaseMarkBlockedTodoResponse();
    message.followup = (object.followup !== undefined && object.followup !== null)
      ? Todo.fromPartial(object.followup)
      : undefined;
    message.workflow_id = object.workflow_id ?? "";
    message.working_days = object.working_days ?? 0;
    message.original = (object.original !== undefined && object.original !== null)
      ? Todo.fromPartial(object.original)
      : undefined;
    message.completion = (object.completion !== undefined && object.completion !== null)
      ? TodoCompletion.fromPartial(object.completion)
      : undefined;
    return message;
  },
};

function createBaseUnblockTodoRequest(): UnblockTodoRequest {
  return { id: "" };
}

export const UnblockTodoRequest: MessageFns<UnblockTodoRequest> = {
  encode(message: UnblockTodoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnblockTodoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnblockTodoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UnblockTodoRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: UnblockTodoRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<UnblockTodoRequest>): UnblockTodoRequest {
    return UnblockTodoRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UnblockTodoRequest>): UnblockTodoRequest {
    const message = createBaseUnblockTodoRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseUnblockTodoResponse(): UnblockTodoResponse {
  return { already_unblocked: false, original: undefined, followup_id: "", completion_id: "" };
}

export const UnblockTodoResponse: MessageFns<UnblockTodoResponse> = {
  encode(message: UnblockTodoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.already_unblocked !== false) {
      writer.uint32(8).bool(message.already_unblocked);
    }
    if (message.original !== undefined) {
      Todo.encode(message.original, writer.uint32(18).fork()).join();
    }
    if (message.followup_id !== "") {
      writer.uint32(26).string(message.followup_id);
    }
    if (message.completion_id !== "") {
      writer.uint32(34).string(message.completion_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnblockTodoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnblockTodoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.already_unblocked = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.original = Todo.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.followup_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.completion_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UnblockTodoResponse {
    return {
      already_unblocked: isSet(object.already_unblocked) ? globalThis.Boolean(object.already_unblocked) : false,
      original: isSet(object.original) ? Todo.fromJSON(object.original) : undefined,
      followup_id: isSet(object.followup_id) ? globalThis.String(object.followup_id) : "",
      completion_id: isSet(object.completion_id) ? globalThis.String(object.completion_id) : "",
    };
  },

  toJSON(message: UnblockTodoResponse): unknown {
    const obj: any = {};
    if (message.already_unblocked !== false) {
      obj.already_unblocked = message.already_unblocked;
    }
    if (message.original !== undefined) {
      obj.original = Todo.toJSON(message.original);
    }
    if (message.followup_id !== "") {
      obj.followup_id = message.followup_id;
    }
    if (message.completion_id !== "") {
      obj.completion_id = message.completion_id;
    }
    return obj;
  },

  create(base?: DeepPartial<UnblockTodoResponse>): UnblockTodoResponse {
    return UnblockTodoResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UnblockTodoResponse>): UnblockTodoResponse {
    const message = createBaseUnblockTodoResponse();
    message.already_unblocked = object.already_unblocked ?? false;
    message.original = (object.original !== undefined && object.original !== null)
      ? Todo.fromPartial(object.original)
      : undefined;
    message.followup_id = object.followup_id ?? "";
    message.completion_id = object.completion_id ?? "";
    return message;
  },
};

function createBaseTodoDelta(): TodoDelta {
  return { server_id: "", client_local_id: "", action: 0, todo: undefined, client_updated_at: undefined };
}

export const TodoDelta: MessageFns<TodoDelta> = {
  encode(message: TodoDelta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.server_id !== "") {
      writer.uint32(10).string(message.server_id);
    }
    if (message.client_local_id !== "") {
      writer.uint32(18).string(message.client_local_id);
    }
    if (message.action !== 0) {
      writer.uint32(24).int32(message.action);
    }
    if (message.todo !== undefined) {
      Todo.encode(message.todo, writer.uint32(34).fork()).join();
    }
    if (message.client_updated_at !== undefined) {
      Timestamp.encode(toTimestamp(message.client_updated_at), writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TodoDelta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTodoDelta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.server_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.client_local_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.action = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.todo = Todo.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.client_updated_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TodoDelta {
    return {
      server_id: isSet(object.server_id) ? globalThis.String(object.server_id) : "",
      client_local_id: isSet(object.client_local_id) ? globalThis.String(object.client_local_id) : "",
      action: isSet(object.action) ? todoDelta_ActionFromJSON(object.action) : 0,
      todo: isSet(object.todo) ? Todo.fromJSON(object.todo) : undefined,
      client_updated_at: isSet(object.client_updated_at) ? globalThis.String(object.client_updated_at) : undefined,
    };
  },

  toJSON(message: TodoDelta): unknown {
    const obj: any = {};
    if (message.server_id !== "") {
      obj.server_id = message.server_id;
    }
    if (message.client_local_id !== "") {
      obj.client_local_id = message.client_local_id;
    }
    if (message.action !== 0) {
      obj.action = todoDelta_ActionToJSON(message.action);
    }
    if (message.todo !== undefined) {
      obj.todo = Todo.toJSON(message.todo);
    }
    if (message.client_updated_at !== undefined) {
      obj.client_updated_at = message.client_updated_at;
    }
    return obj;
  },

  create(base?: DeepPartial<TodoDelta>): TodoDelta {
    return TodoDelta.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TodoDelta>): TodoDelta {
    const message = createBaseTodoDelta();
    message.server_id = object.server_id ?? "";
    message.client_local_id = object.client_local_id ?? "";
    message.action = object.action ?? 0;
    message.todo = (object.todo !== undefined && object.todo !== null) ? Todo.fromPartial(object.todo) : undefined;
    message.client_updated_at = object.client_updated_at ?? undefined;
    return message;
  },
};

function createBaseTodoSyncPushRequest(): TodoSyncPushRequest {
  return { deltas: [] };
}

export const TodoSyncPushRequest: MessageFns<TodoSyncPushRequest> = {
  encode(message: TodoSyncPushRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.deltas) {
      TodoDelta.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TodoSyncPushRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTodoSyncPushRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deltas.push(TodoDelta.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TodoSyncPushRequest {
    return {
      deltas: globalThis.Array.isArray(object?.deltas) ? object.deltas.map((e: any) => TodoDelta.fromJSON(e)) : [],
    };
  },

  toJSON(message: TodoSyncPushRequest): unknown {
    const obj: any = {};
    if (message.deltas?.length) {
      obj.deltas = message.deltas.map((e) => TodoDelta.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<TodoSyncPushRequest>): TodoSyncPushRequest {
    return TodoSyncPushRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TodoSyncPushRequest>): TodoSyncPushRequest {
    const message = createBaseTodoSyncPushRequest();
    message.deltas = object.deltas?.map((e) => TodoDelta.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTodoSyncPushResponse(): TodoSyncPushResponse {
  return { mappings: [], rejected_client_ids: [] };
}

export const TodoSyncPushResponse: MessageFns<TodoSyncPushResponse> = {
  encode(message: TodoSyncPushResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.mappings) {
      TodoSyncPushResponse_IdMapping.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.rejected_client_ids) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TodoSyncPushResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTodoSyncPushResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mappings.push(TodoSyncPushResponse_IdMapping.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.rejected_client_ids.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TodoSyncPushResponse {
    return {
      mappings: globalThis.Array.isArray(object?.mappings)
        ? object.mappings.map((e: any) => TodoSyncPushResponse_IdMapping.fromJSON(e))
        : [],
      rejected_client_ids: globalThis.Array.isArray(object?.rejected_client_ids)
        ? object.rejected_client_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: TodoSyncPushResponse): unknown {
    const obj: any = {};
    if (message.mappings?.length) {
      obj.mappings = message.mappings.map((e) => TodoSyncPushResponse_IdMapping.toJSON(e));
    }
    if (message.rejected_client_ids?.length) {
      obj.rejected_client_ids = message.rejected_client_ids;
    }
    return obj;
  },

  create(base?: DeepPartial<TodoSyncPushResponse>): TodoSyncPushResponse {
    return TodoSyncPushResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TodoSyncPushResponse>): TodoSyncPushResponse {
    const message = createBaseTodoSyncPushResponse();
    message.mappings = object.mappings?.map((e) => TodoSyncPushResponse_IdMapping.fromPartial(e)) || [];
    message.rejected_client_ids = object.rejected_client_ids?.map((e) => e) || [];
    return message;
  },
};

function createBaseTodoSyncPushResponse_IdMapping(): TodoSyncPushResponse_IdMapping {
  return { client_local_id: "", server_id: "" };
}

export const TodoSyncPushResponse_IdMapping: MessageFns<TodoSyncPushResponse_IdMapping> = {
  encode(message: TodoSyncPushResponse_IdMapping, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.client_local_id !== "") {
      writer.uint32(10).string(message.client_local_id);
    }
    if (message.server_id !== "") {
      writer.uint32(18).string(message.server_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TodoSyncPushResponse_IdMapping {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTodoSyncPushResponse_IdMapping();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.client_local_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.server_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TodoSyncPushResponse_IdMapping {
    return {
      client_local_id: isSet(object.client_local_id) ? globalThis.String(object.client_local_id) : "",
      server_id: isSet(object.server_id) ? globalThis.String(object.server_id) : "",
    };
  },

  toJSON(message: TodoSyncPushResponse_IdMapping): unknown {
    const obj: any = {};
    if (message.client_local_id !== "") {
      obj.client_local_id = message.client_local_id;
    }
    if (message.server_id !== "") {
      obj.server_id = message.server_id;
    }
    return obj;
  },

  create(base?: DeepPartial<TodoSyncPushResponse_IdMapping>): TodoSyncPushResponse_IdMapping {
    return TodoSyncPushResponse_IdMapping.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TodoSyncPushResponse_IdMapping>): TodoSyncPushResponse_IdMapping {
    const message = createBaseTodoSyncPushResponse_IdMapping();
    message.client_local_id = object.client_local_id ?? "";
    message.server_id = object.server_id ?? "";
    return message;
  },
};

function createBaseTodoSyncPullRequest(): TodoSyncPullRequest {
  return { since: undefined, limit: 0 };
}

export const TodoSyncPullRequest: MessageFns<TodoSyncPullRequest> = {
  encode(message: TodoSyncPullRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.since !== undefined) {
      Timestamp.encode(toTimestamp(message.since), writer.uint32(10).fork()).join();
    }
    if (message.limit !== 0) {
      writer.uint32(16).int32(message.limit);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TodoSyncPullRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTodoSyncPullRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.since = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.limit = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TodoSyncPullRequest {
    return {
      since: isSet(object.since) ? globalThis.String(object.since) : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : 0,
    };
  },

  toJSON(message: TodoSyncPullRequest): unknown {
    const obj: any = {};
    if (message.since !== undefined) {
      obj.since = message.since;
    }
    if (message.limit !== 0) {
      obj.limit = Math.round(message.limit);
    }
    return obj;
  },

  create(base?: DeepPartial<TodoSyncPullRequest>): TodoSyncPullRequest {
    return TodoSyncPullRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TodoSyncPullRequest>): TodoSyncPullRequest {
    const message = createBaseTodoSyncPullRequest();
    message.since = object.since ?? undefined;
    message.limit = object.limit ?? 0;
    return message;
  },
};

function createBaseTodoSyncPullResponse(): TodoSyncPullResponse {
  return { todos: [], cursor: undefined, has_more: false };
}

export const TodoSyncPullResponse: MessageFns<TodoSyncPullResponse> = {
  encode(message: TodoSyncPullResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.todos) {
      Todo.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.cursor !== undefined) {
      Timestamp.encode(toTimestamp(message.cursor), writer.uint32(18).fork()).join();
    }
    if (message.has_more !== false) {
      writer.uint32(24).bool(message.has_more);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TodoSyncPullResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTodoSyncPullResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.todos.push(Todo.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cursor = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.has_more = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TodoSyncPullResponse {
    return {
      todos: globalThis.Array.isArray(object?.todos) ? object.todos.map((e: any) => Todo.fromJSON(e)) : [],
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : undefined,
      has_more: isSet(object.has_more) ? globalThis.Boolean(object.has_more) : false,
    };
  },

  toJSON(message: TodoSyncPullResponse): unknown {
    const obj: any = {};
    if (message.todos?.length) {
      obj.todos = message.todos.map((e) => Todo.toJSON(e));
    }
    if (message.cursor !== undefined) {
      obj.cursor = message.cursor;
    }
    if (message.has_more !== false) {
      obj.has_more = message.has_more;
    }
    return obj;
  },

  create(base?: DeepPartial<TodoSyncPullResponse>): TodoSyncPullResponse {
    return TodoSyncPullResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TodoSyncPullResponse>): TodoSyncPullResponse {
    const message = createBaseTodoSyncPullResponse();
    message.todos = object.todos?.map((e) => Todo.fromPartial(e)) || [];
    message.cursor = object.cursor ?? undefined;
    message.has_more = object.has_more ?? false;
    return message;
  },
};

function createBaseTodoCompletionSyncPullRequest(): TodoCompletionSyncPullRequest {
  return { since: undefined, limit: 0, since_id: "" };
}

export const TodoCompletionSyncPullRequest: MessageFns<TodoCompletionSyncPullRequest> = {
  encode(message: TodoCompletionSyncPullRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.since !== undefined) {
      Timestamp.encode(toTimestamp(message.since), writer.uint32(10).fork()).join();
    }
    if (message.limit !== 0) {
      writer.uint32(16).int32(message.limit);
    }
    if (message.since_id !== "") {
      writer.uint32(26).string(message.since_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TodoCompletionSyncPullRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTodoCompletionSyncPullRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.since = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.limit = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.since_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TodoCompletionSyncPullRequest {
    return {
      since: isSet(object.since) ? globalThis.String(object.since) : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : 0,
      since_id: isSet(object.since_id) ? globalThis.String(object.since_id) : "",
    };
  },

  toJSON(message: TodoCompletionSyncPullRequest): unknown {
    const obj: any = {};
    if (message.since !== undefined) {
      obj.since = message.since;
    }
    if (message.limit !== 0) {
      obj.limit = Math.round(message.limit);
    }
    if (message.since_id !== "") {
      obj.since_id = message.since_id;
    }
    return obj;
  },

  create(base?: DeepPartial<TodoCompletionSyncPullRequest>): TodoCompletionSyncPullRequest {
    return TodoCompletionSyncPullRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TodoCompletionSyncPullRequest>): TodoCompletionSyncPullRequest {
    const message = createBaseTodoCompletionSyncPullRequest();
    message.since = object.since ?? undefined;
    message.limit = object.limit ?? 0;
    message.since_id = object.since_id ?? "";
    return message;
  },
};

function createBaseTodoCompletionSyncPullResponse(): TodoCompletionSyncPullResponse {
  return { items: [], cursor: undefined, has_more: false, cursor_id: "" };
}

export const TodoCompletionSyncPullResponse: MessageFns<TodoCompletionSyncPullResponse> = {
  encode(message: TodoCompletionSyncPullResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      TodoCompletion.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.cursor !== undefined) {
      Timestamp.encode(toTimestamp(message.cursor), writer.uint32(18).fork()).join();
    }
    if (message.has_more !== false) {
      writer.uint32(24).bool(message.has_more);
    }
    if (message.cursor_id !== "") {
      writer.uint32(34).string(message.cursor_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TodoCompletionSyncPullResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTodoCompletionSyncPullResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.items.push(TodoCompletion.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cursor = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.has_more = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.cursor_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TodoCompletionSyncPullResponse {
    return {
      items: globalThis.Array.isArray(object?.items) ? object.items.map((e: any) => TodoCompletion.fromJSON(e)) : [],
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : undefined,
      has_more: isSet(object.has_more) ? globalThis.Boolean(object.has_more) : false,
      cursor_id: isSet(object.cursor_id) ? globalThis.String(object.cursor_id) : "",
    };
  },

  toJSON(message: TodoCompletionSyncPullResponse): unknown {
    const obj: any = {};
    if (message.items?.length) {
      obj.items = message.items.map((e) => TodoCompletion.toJSON(e));
    }
    if (message.cursor !== undefined) {
      obj.cursor = message.cursor;
    }
    if (message.has_more !== false) {
      obj.has_more = message.has_more;
    }
    if (message.cursor_id !== "") {
      obj.cursor_id = message.cursor_id;
    }
    return obj;
  },

  create(base?: DeepPartial<TodoCompletionSyncPullResponse>): TodoCompletionSyncPullResponse {
    return TodoCompletionSyncPullResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TodoCompletionSyncPullResponse>): TodoCompletionSyncPullResponse {
    const message = createBaseTodoCompletionSyncPullResponse();
    message.items = object.items?.map((e) => TodoCompletion.fromPartial(e)) || [];
    message.cursor = object.cursor ?? undefined;
    message.has_more = object.has_more ?? false;
    message.cursor_id = object.cursor_id ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(dateStr: string): Timestamp {
  const date = new globalThis.Date(dateStr);
  const seconds = Math.trunc(date.getTime() / 1_000).toString();
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): string {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis).toISOString();
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
